export enum GLOBAL {
    /**
     * @value {"one":"1 new item loaded","other":"%NB_OF_ITEMS% new items loaded"}
     * @description Message read by screen readers when new items are loaded after clicking a Show more button. %NB_OF_ITEMS% is the number of items that were just added to the list. This message is not displayed visually.
     */
    A11Y_NB_NEW_ITEMS_LOADED = 'GLOBAL.A11Y_NB_NEW_ITEMS_LOADED',
    /**
     * @value Aborted
     */
    ABORTED = 'GLOBAL.ABORTED',
    /**
     * @value About
     */
    ABOUT = 'ABOUT',
    /**
     * @value Accept
     * @description Text to be displayed on an action that accepts a message or a modal
     */
    ACCEPT = 'GLOBAL.ACCEPT',
    /**
     * @value Accepted
     * @description Label used for accessibility purpose in order to display the event status for the current user.
     */
    ACCEPTED = 'CALENDAR.EVENT_STATUS_ACCEPTED_ARIA_LABEL',
    /**
     * @value Access
     */
    ACCESS = 'ACCESS',
    /**
     * @value Access the previous layout of this page
     * @description This key will be a link to previous layout page, to offer the user a way to go back to former UI.
     */
    ACCESS_PREVIOUS_PAGE = 'ADMIN.GROUP.ACCESS_PREVIOUS_PAGE',
    /**
     * @value access request
     */
    ACCESS_REQUEST = 'ACCESS_REQUEST',
    /**
     * @value access requests
     */
    ACCESS_REQUESTS = 'ACCESS_REQUESTS',
    /**
     * @value Achievements
     */
    ACHIEVEMENTS = 'SOCIAL_PROFILE_ACHIEVEMENTS',
    /**
     * @value Acknowledged
     * @description Usually displayed in a color chip/flag to show that a user has confirmed that she has read/taken into consideration the related resource or notification
     */
    ACKNOWLEDGED = 'GLOBAL.ACKNOWLEDGED',
    /**
     * @value Actions
     * @description label to describe a group of actions
     */
    ACTIONS = 'GLOBAL.ACTIONS',
    /**
     * @value Action could not be completed. Try again or come back later.
     * @description Error notice saying the action encountered some issues and could not be completed
     */
    ACTION_NOT_COMPLETED_TRY_AGAIN = 'GLOBAL.ACTION_NOT_COMPLETED_TRY_AGAIN',
    /**
     * @value Activate
     * @description Useful when allowing the user to activate something.
     */
    ACTIVATE = 'GLOBAL.ACTIVATE',
    /**
     * @value Activated
     */
    ACTIVATED = 'GLOBAL.ACTIVATED',
    /**
     * @value Activation
     * @description Display activation label
     */
    ACTIVATION = 'GLOBAL.ACTIVATION',
    /**
     * @value Activations
     * @description Use to display activations label or title
     */
    ACTIVATIONS = 'GLOBAL.ACTIVATIONS',
    /**
     * @value Active
     */
    ACTIVE = 'ACTIVE',
    /**
     * @value {"one":"%NUMBER% active filter","other":"%NUMBER% active filters"}
     */
    ACTIVE_FILTERS = 'GLOBAL.ACTIVE_FILTERS',
    /**
     * @value Activities
     * @description 'Activities' Emoji category used on the emoji picker
     */
    ACTIVITIES = 'EMOJI_PICKER.CATEGORY_ACTIVITIES',
    /**
     * @value Activity
     * @description Single word "Activiy"
     */
    ACTIVITY = 'GLOBAL.ACTIVITY',
    /**
     * @value Add
     * @description Useful when allowing the user to add something.
     */
    ADD = 'GLOBAL.ADD',
    /**
     * @value Add alt text
     * @description Text found on the button to add an alternative text on an image.
     */
    ADD_ALT_TEXT = 'WREX_IMAGE.INSERT_ALT_TEXT_ADD',
    /**
     * @value Add a comment...
     */
    ADD_A_COMMENT = 'FRONT.COMMENTS.ADD_A_COMMENT',
    /**
     * @value Add a message
     * @description Prompts the user the add a message.
     */
    ADD_A_MESSAGE = 'GLOBAL.ADD_A_MESSAGE',
    /**
     * @value Add a string
     */
    ADD_A_STRING = 'GLOBAL.ADD_A_STRING',
    /**
     * @value Add a description
     * @description Placeholder for description field when adding new expression for ask ai
     */
    ADD_DESCRIPTION = 'ASK_LUMAPPS_CONCEPTS.DESCRIPTION_FIELD_PLACEHOLDER',
    /**
     * @value Add featured image
     */
    ADD_FEATURED_IMAGE = 'WREX_AI.ADD_FEATURED_IMAGE',
    /**
     * @value Add groups
     */
    ADD_GROUPS = 'GLOBAL.ADD_GROUPS',
    /**
     * @value Add here
     * @description Simple text to call users to add something at a specific location.
     */
    ADD_HERE = 'GLOBAL.ADD_HERE',
    /**
     * @value Add a language
     */
    ADD_LANGUAGE = 'GLOBAL.ADD_LANGUAGE',
    /**
     * @value Add a name
     */
    ADD_NAME = 'CONNECTORS.PLACEHOLDER_ADD_NAME',
    /**
     * @value Add photo
     */
    ADD_PHOTO = 'FRONT.SOCIAL_ADVOCACY.SHAREABLE_WORKFLOW.ADD_PHOTO',
    /**
     * @value Add photos
     */
    ADD_PHOTOS = 'FRONT.SOCIAL_ADVOCACY.SHAREABLE_WORKFLOW.ADD_PHOTOS',
    /**
     * @value Add sites
     */
    ADD_SITES = 'GLOBAL.ADD_SITES',
    /**
     * @value Add source
     * @description action
     */
    ADD_SOURCE = 'SEARCH_SETTINGS.ADD_SOURCE',
    /**
     * @value Add users
     */
    ADD_USERS = 'GLOBAL.ADD_USERS',
    /**
     * @value Add version
     */
    ADD_VERSION = 'LANGUAGES.ADD_VERSION',
    /**
     * @value Add video
     * @description Text that can be used to label a video allowing the user to add a video (in a library, gallery, playlist, post etc…)
     */
    ADD_VIDEO = 'GLOBAL.ADD_VIDEO',
    /**
     * @value Administration
     */
    ADMINISTRATION = 'ADMIN.NAV.TITLE',
    /**
     * @value Administrators
     */
    ADMINISTRATORS = 'ADMIN.NAV.INSTANCE_ADMINS',
    /**
     * @value Advanced
     * @description Text to display an Advanced section
     */
    ADVANCED = 'GLOBAL.ADVANCED',
    /**
     * @value Advanced member
     */
    ADVANCED_MEMBER = 'GLOBAL.ROLE_ADVANCED_MEMBER',
    /**
     * @value Advanced settings
     */
    ADVANCED_SETTINGS = 'ADMIN.NAV.CUSTOMER_ADVANCED_SETTINGS',
    /**
     * @value After
     */
    AFTER = 'GLOBAL.AFTER',
    /**
     * @value Agents
     * @description "Agents" feature label
     */
    AGENTS = 'GLOBAL.AGENTS',
    /**
     * @value Agent Hub
     * @description "Agent hub" feature translation key.
     */
    AGENT_HUB = 'GLOBAL.AGENT_HUB',
    /**
     * @value Agree
     * @description Useful when allowing the user to Agree on a specific action
     */
    AGREE = 'GLOBAL.AGREE_ACTION',
    /**
     * @value AI can make mistakes. Check important info.
     * @description Disclaimer to use with AI features to explain that they should be double checked.
     */
    AI_DISCLAIMER = 'GLOBAL.AI_DISCLAIMER',
    /**
     * @value AI generated result
     */
    AI_GENERATED_RESULT = 'WREX_AI.GENERATED_RESULT',
    /**
     * @value All
     * @description Useful when displaying a message that relates to ALL entities
     */
    ALL = 'GLOBAL.ALL',
    /**
     * @value All sites
     */
    ALL_SITES = 'SOCIAL_PROFILE_FILTER_PLATFORM',
    /**
     * @value All-time
     * @description Word used to filter temporality of an element to All-time (contrary to past, ongoing or future)
     */
    ALL_TIME = 'GLOBAL.ALL_TIME',
    /**
     * @value All users
     */
    ALL_USERS = 'GLOBAL.ALL_USERS',
    /**
     * @value Alphabetical order
     * @description Tags sorter
     */
    ALPHABETICAL_ORDER = 'ADMIN.FOLKSONOMY.FILTER.ALPHA_ASC',
    /**
     * @value Reverse alphabetical order
     * @description Sort tags alphabetically reverse
     */
    ALPHABETICAL_ORDER_DESC = 'ADMIN.FOLKSONOMY.FILTER.ALPHA_DESC',
    /**
     * @value Already added
     * @description Small indicator in an user picker to notice that the user has been already added
     */
    ALREADY_ADDED = 'GLOBAL.ALREADY_ADDED',
    /**
     * @value Already used
     * @description generic label to already used items
     */
    ALREADY_USED = 'GLOBAL.ALREADY_USED',
    /**
     * @value "%VALUE%" is already used
     * @description Displayed when the user searches for a value that is already selected. This is displayed instead of the 'Use %VALUE%' message in order to avoid having the user creating duplicated value unintentionally.
     */
    ALREADY_USED_VALUE = 'GLOBAL.ALREADY_USED_VALUE',
    /**
     * @value Analytics
     * @description Text to be used when displaying the Analytics feature
     */
    ANALYTICS = 'GLOBAL.ANALYTICS',
    /**
     * @value Analytics dashboards
     */
    ANALYTICS_DASHBOARDS = 'GLOBAL.ANALYTICS_DASHBOARDS',
    /**
     * @value Analyzing the file...
     */
    ANALYZING_FILE = 'GLOBAL.ANALYZING_FILE',
    /**
     * @value and
     * @description Conjunction 'and' added as a global key as it can be useful in any context.
     */
    AND = 'GLOBAL.AND',
    /**
     * @value {"one":"answer","other":"answers"}
     * @description Used in a counter of answers (in a survey for instance)
     */
    ANSWER = 'GLOBAL.ANSWER',
    /**
     * @value Answers are generated by AI.
     * @description Disclaimer displayed at the bottom of Assistant bot.
     */
    ANSWERS_GENERATED_BY_AI = 'GLOBAL.ANSWERS_GENERATED_BY_AI',
    /**
     * @value Any time
     * @description Option into a select field to pick videos from any time in smart playlist.
     * In French: Date indifférente
     */
    ANYTIME = 'PLAY.SINCE_ANY_TIME',
    /**
     * @value App
     */
    APP = 'GLOBAL.APP',
    /**
     * @value Application name
     */
    APPLICATION_NAME = 'MOBILE_BRANDED_APPS.APPLICATION_NAME_LABEL',
    /**
     * @value {"one":"Applies to %ENTITIES%","other":"Applies to %ENTITIES% and %ENTITY%"}
     */
    APPLIES_TO = 'GLOBAL.APPLIES_TO',
    /**
     * @value Apply
     * @description Message to be displayed on a button that will apply something
     */
    APPLY = 'APPLY',
    /**
     * @value Apply changes
     * @description message to be displayed on a button that will apply changes
     */
    APPLY_CHANGES = 'GLOBAL.APPLY_CHANGES',
    /**
     * @value Apply my filters selections
     * @description This key will be used in order to display a long form text in a form button that will trigger some sort of filtering based on a previous selection of filters. Can be used in association with GLOBAL.APPLY    in order to give more context to the user on what will be applied.
     */
    APPLY_FILTERS = 'GLOBAL.APPLY_FILTERS',
    /**
     * @value Approximately
     * @description This key is used to tell the user that the data around is not exact. For example, we can use it after a date: March 30, 2023 at 8:00am (approximately)
     */
    APPROXIMATELY = 'GLOBAL.APPROXIMATELY',
    /**
     * @value App Logo
     * @description Title of the section where we find an uploader
     */
    APP_LOGO = 'GLOBAL.APP_LOGO',
    /**
     * @value Archivable/Unarchivable
     */
    ARCHIVABLE = 'CAN_PAGE_ARCHIVE',
    /**
     * @value Archive
     */
    ARCHIVE = 'ARCHIVE',
    /**
     * @value Archived
     */
    ARCHIVED = 'GLOBAL.ARCHIVED',
    /**
     * @value Article
     */
    ARTICLE = 'GLOBAL.ARTICLE',
    /**
     * @value Articles
     * @description A kind of rich text document
     */
    ARTICLES = 'COMMUNITY_SETTINGS.ARTICLE_SERVICE_TITLE',
    /**
     * @value Ascending
     */
    ASCENDING = 'FRONT.SETTINGS.ASCENDING_SORT_ORDER',
    /**
     * @value Ask AI
     * @description Don't translate yet. The name of the Ask-Ai package.
     */
    ASK_AI = 'GLOBAL.ASK_AI',
    /**
     * @value Ask a question or search...
     * @description Placeholder displayed in the searchbox when the user can use Ask AI
     */
    ASK_QUESTION_OR_SEARCH = 'ASK_AI.ASK_QUESTION_OR_SEARCH',
    /**
     * @value At
     * @description Label used on time picker field, generally used with a date picker next to it
     */
    AT = 'GLOBAL.AT',
    /**
     * @value Attach
     * @description Used to describe an attachments section name
     */
    ATTACH = 'GLOBAL.ATTACH',
    /**
     * @value Attachment
     * @description Here an "attachment" can be a website URL, an article, etc. something that can be opened and read by a user. A link to the "attachment" can be sent via email.
     */
    ATTACHMENT = 'JOURNEYS_CORE.ATTACHMENT',
    /**
     * @value Attendance status
     */
    ATTENDANCE_STATUS = 'GLOBAL.ATTENDANCE_STATUS',
    /**
     * @value Attended
     */
    ATTENDED = 'GLOBAL.ATTENDED',
    /**
     * @value Audience
     * @description Initially displayed as the title of the groups section in the rules creation form.
     */
    AUDIENCE = 'GLOBAL.AUDIENCE',
    /**
     * @value Authentication failed
     */
    AUTHENTICATION_FAILED = 'SERVER_ERROR_LOGIN_TOKEN_INVALID',
    /**
     * @value Author
     * @description The content's author
     */
    AUTHOR = 'GLOBAL.AUTHOR',
    /**
     * @value Authorization code
     */
    AUTHORIZATION_CODE = 'CONNECTORS.AUTHORIZATION_CODE',
    /**
     * @value Authorization URL
     */
    AUTHORIZATION_URL = 'CONNECTORS.AUTHORIZATION_URI',
    /**
     * @value Third-party authorization URL
     */
    AUTHORIZATION_URL_HELPER = 'CONNECTORS.AUTHORIZATION_URI_HELPER',
    /**
     * @value Auto-translate
     * @description Label used on button to auto translate text using google translation or other provider
     */
    AUTOTRANSLATE = 'DESIGNER_TRANSLATIONS.AUTOTRANSLATE',
    /**
     * @value Availability
     * @description Text that can be used as the title of a section where the user can manage the availability of a given entity (is my entity accessible in this content type or not?, etc…)
     */
    AVAILABILITY = 'GLOBAL.AVAILABILITY',
    /**
     * @value Available in
     * @description The phrase "Available in" in order to present the different alternatives for a given entity. For example, "Available in: English, French, Spanish"
     */
    AVAILABLE_IN = 'GLOBAL.AVAILABLE_IN',
    /**
     * @value Avatar
     */
    AVATAR = 'GLOBAL.AVATAR',
    /**
     * @value %A% or %B%
     * @description Key with variables when we want to display 2 options. For example %A% and %B% can be Apples/bananas (Apples or bananas), Dollar/Euros (Dollars or Euros) and so on.
     */
    A_OR_B = 'GLOBAL.A_OR_B',
    /**
     * @value Back
     * @description Used for instance for buttons to go back one step in the context of a stepper --in the context of a workflow with several steps--
     */
    BACK = 'GLOBAL.BACK',
    /**
     * @value Background
     */
    BACKGROUND = 'STYLE.BACKGROUND',
    /**
     * @value Background color
     */
    BACKGROUND_COLOR = 'STYLE.BACKGROUND_COLOR',
    /**
     * @value Back to current version
     */
    BACK_TO_CURRENT_VERSION = 'GLOBAL.BACK_TO_CURRENT_VERSION',
    /**
     * @value Back to draft
     */
    BACK_TO_DRAFT = 'GLOBAL.BACK_TO_DRAFT',
    /**
     * @value Back to Home
     * @description Label of the button that lets the user go back to the home page from a different page.
     */
    BACK_TO_HOME = 'GLOBAL.BACK_TO_HOME',
    /**
     * @value Basic
     * @description Single word "basic"
     */
    BASIC = 'GLOBAL.BASIC',
    /**
     * @value Beekeeper
     */
    BEEKEEPER = 'IDENTITY_PROVIDER.BEEKEEPER',
    /**
     * @value Before
     */
    BEFORE = 'GLOBAL.BEFORE',
    /**
     * @value Beta
     */
    BETA = 'GLOBAL.BETA',
    /**
     * @value Body
     */
    BODY = 'CONNECTORS.CREDENTIALS.BODY',
    /**
     * @value Applications
     * @description Text used for displaying the bookmarked apps icon, usually used on the top bar
     */
    BOOKMARKED_APPS = 'GLOBAL.BOOKMARKED_APPS',
    /**
     * @value Breadcrumb
     * @description Used as an aria-label to define a breadcrumb
     */
    BREADCRUMB = 'GLOBAL.BREADCRUMB',
    /**
     * @value Broadcast
     * @description Global key for the Broadcast entity
     */
    BROADCAST = 'GLOBAL.BROADCAST',
    /**
     * @value by
     */
    BY = 'BY',
    /**
     * @value By %VALUE%
     * @description Text used to display things like "By Email"
     */
    BY_VALUE = 'GLOBAL.BY_VALUE',
    /**
     * @value By %VALUE% on behalf of %BEHALF%
     * @description Text used to display things like "By Email on behalf of HR team"
     */
    BY_VALUE_ON_BEHALF = 'GLOBAL.BY_VALUE_ON_BEHALF',
    /**
     * @value Calendar
     * @description Single word "Calendar"
     */
    CALENDAR = 'GLOBAL.CALENDAR',
    /**
     * @value Cancel
     * @description used when displaying either a modal, a confirmation message or an action that needs to be canceled.
     */
    CANCEL = 'GLOBAL.CANCEL',
    /**
     * @value Capture
     */
    CAPTURE = 'GLOBAL.CAPTURE',
    /**
     * @value Carousel
     * @description "Carousel" is a UI/design definition and should not be translated.
     */
    CAROUSEL = 'GLOBAL.CAROUSEL',
    /**
     * @value Catalog
     */
    CATALOG = 'GLOBAL.CATALOG',
    /**
     * @value Categories
     */
    CATEGORIES = 'WIDGET_POST_LIST.CATEGORIES',
    /**
     * @value Category
     * @description Single word "category"
     */
    CATEGORY = 'GLOBAL.CATEGORY',
    /**
     * @value Challenge
     * @description Title for learning activity of type quiz
     */
    CHALLENGE = 'GLOBAL.CHALLENGE',
    /**
     * @value Change
     */
    CHANGE = 'PAGE.REVIEW.CHANGE',
    /**
     * @value Changes saved successfully
     * @description Changes saved successfully
     */
    CHANGES_CHANGED = 'GLOBAL.CHANGES_CHANGED',
    /**
     * @value Your changes have not been saved.
     * @description Text warning the user that his changes have not been saved
     */
    CHANGES_NOT_SAVED = 'GLOBAL.CHANGES_NOT_SAVED',
    /**
     * @value Chat
     */
    CHAT = 'BOOKMARKED_APPS_CHAT',
    /**
     * @value Chats
     * @description Name of the chats feature
     */
    CHATS = 'GLOBAL.CHATS',
    /**
     * @value Check status
     */
    CHECK_STATUS = 'ADMIN.CUSTOMER.HOOKS.CHECK_STATUS',
    /**
     * @value Choose a date
     * @description a label that can be used in a radio button to tell the user she can... choose a specific date
     */
    CHOOSE_A_DATE = 'GLOBAL.CHOOSE_A_DATE',
    /**
     * @value Clear
     * @description Single word "clear"
     */
    CLEAR = 'GLOBAL.CLEAR',
    /**
     * @value Clear all
     */
    CLEAR_ALL = 'REPORTS.CLEAR_ALL',
    /**
     * @value clear all filters
     */
    CLEAR_ALL_FILTERS = 'GLOBAL.CLEAR_ALL_FILTERS',
    /**
     * @value Clear filter
     * @description Message to display on an action that will remove the current filters
     */
    CLEAR_FILTER = 'GLOBAL.CLEAR_FILTER',
    /**
     * @value Clear search
     * @description Label for the "clear" button of search fields.
     */
    CLEAR_SEARCH = 'GLOBAL.CLEAR_SEARCH',
    /**
     * @value Client credentials
     */
    CLIENT_CREDENTIALS = 'CONNECTORS.CLIENT_CREDENTIALS_NEW',
    /**
     * @value Client ID
     */
    CLIENT_ID = 'CONNECTORS.CLIENT_ID',
    /**
     * @value The client ID is generated by the third-party application
     */
    CLIENT_ID_HELPER = 'CONNECTORS.CLIENT_ID_HELPER',
    /**
     * @value Client secret
     */
    CLIENT_SECRET = 'CONNECTORS.CLIENT_SECRET',
    /**
     * @value The client secret is generated by the third-party application.
     */
    CLIENT_SECRET_HELPER = 'CONNECTORS.CLIENT_SECRET_HELPER',
    /**
     * @value Close
     * @description "Close" text, usually displayed when dismissing a modal or a message
     */
    CLOSE = 'GLOBAL.CLOSE',
    /**
     * @value CloudSearch
     * @description Text to be used when referencing the Cloudsearch service
     */
    CLOUDSEARCH = 'GLOBAL.CLOUDSEARCH',
    /**
     * @value Collapse
     * @description Global key used for describing an action that collapses the current view. Like a button that when you click on it, the page that you are seeing collapses
     */
    COLLAPSE = 'GLOBAL.COLLAPSE',
    /**
     * @value Collapsed
     */
    COLLAPSED = 'GLOBAL.COLLAPSED',
    /**
     * @value Color
     */
    COLOR = 'STYLE.COLOR',
    /**
     * @value comment
     */
    COMMENT = 'COMMENT_BUTTON_LABEL',
    /**
     * @value comments
     */
    COMMENTS = 'COMMENT_BUTTON_LABEL_PLURAL',
    COMMENT_PLURALIZE = 'GLOBAL.COMMENT_PLURALIZE',
    /**
     * @value Communities
     */
    COMMUNITIES = 'ADMIN.NAV.COMMUNITIES',
    /**
     * @value Community
     * @description A placeholder key that will be reused whenever we reference the word 'Community' on its own.
     */
    COMMUNITY = 'GLOBAL.COMMUNITY',
    /**
     * @value Completed
     */
    COMPLETED = 'GLOBAL.COMPLETED',
    /**
     * @value Only completed translations will be sent and accessible to users.
     */
    COMPLETED_TRANSLATIONS = 'LANGUAGES.COMPLETED_TRANSLATIONS',
    /**
     * @value Completion
     */
    COMPLETION = 'GLOBAL.COMPLETION',
    /**
     * @value Conditions
     * @description Initially displayed as the title of the customization section of the rules creation form.
     * (Expressions, custom answer, sources)
     */
    CONDITIONS = 'GLOBAL.CONDITIONS',
    /**
     * @value Configuration
     * @description Single word "Configuration"
     */
    CONFIGURATION = 'GLOBAL.CONFIGURATION',
    /**
     * @value Confirm
     * @description used when displaying either a modal or an action that needs to be confirmed.
     */
    CONFIRM = 'GLOBAL.CONFIRM',
    /**
     * @value Confirm close
     * @description Title of the alter dialog asking the user to confirm the close of the picker dialog (loosing the current selection)
     */
    CONFIRM_CLOSE = 'GLOBAL.PICKER_DIALOG.CONFIRM_CLOSE_TITLE',
    /**
     * @value Are you sure you want to close the picker and lose the current selection?
     * @description The description of the alert dialog asking the user to confirm the closing of the picker dialog (loosing current selection)
     */
    CONFIRM_CLOSE_DESCRIPTION = 'GLOBAL.PICKER_DIALOG.CONFIRM_CLOSE_DESCRIPTION',
    /**
     * @value Confirm source language
     */
    CONFIRM_SOURCE_LANGUAGE = 'LANGUAGES.CONFIRM_SOURCE_LANGUAGE',
    /**
     * @todo: CHANGE THE KEY TO GLOBAL.CONNECT
     * @value Connect
     * @description action to save connection
     */
    CONNECT = 'ADMIN.SEARCH_SETTINGS.CONNECTION_SUBMIT',
    /**
     * @todo: CHANGE THE KEY TO GLOBAL.CONNECTED
     * @value Connected
     */
    CONNECTED = 'FRONT.SOCIAL_ADVOCACY.SOCIAL_PLATFORM_CONNECTED',
    /**
     * @value Connected as %USER%
     * @description Global text to be used across the product in order to display that the current user is connected as someone with a specific username.
     *
     * For example: "Connected as John Doe".
     */
    CONNECTED_AS = 'GLOBAL.CONNECTED_AS',
    /**
     * @value Connection
     * @description Single word "Connection"
     */
    CONNECTION = 'GLOBAL.CONNECTION',
    /**
     * @value Connections
     * @description Single word "Connections"
     */
    CONNECTIONS = 'GLOBAL.CONNECTIONS',
    /**
     * @value Connection required
     */
    CONNECTION_REQUIRED = 'GLOBAL.CONNECTION_REQUIRED',
    /**
     * @value Connectors
     * @description Connectors name for technical feature flag
     */
    CONNECTORS = 'GLOBAL.CONNECTORS',
    /**
     * @value Contact email
     */
    CONTACT_EMAIL = 'ADMIN_CUSTOMER_CONTACT_EMAIL',
    /**
     * @value Content
     * @description Global key to be used when taking about a Content
     */
    CONTENT = 'GLOBAL.CONTENT',
    /**
     * @value Contents
     */
    CONTENTS = 'GLOBAL.CONTENTS',
    /**
     * @value %CONTENTS% in %CONTAINER%
     * @description Compound key to describe that something is contained is something else.
     * E.g "Articles in my community" or "Post in the website of Ariana"
     */
    CONTENTS_IN_CONTAINER = 'GLOBAL.CONTENTS_IN_CONTAINER',
    /**
     * @value Content hidden
     */
    CONTENT_HIDDEN = 'GLOBAL.CONTENT_HIDDEN',
    /**
     * @value Content list
     */
    CONTENT_LIST = 'GLOBAL.CONTENT_LIST',
    /**
     * @value Content stream
     */
    CONTENT_STREAM = 'MOBILE.HOME_PAGE_SECTION_CONTENT_STREAM_TITLE',
    /**
     * @value Content type
     */
    CONTENT_TYPE = 'CONTENT_TYPE_CUSTOM',
    /**
     * @value Content types
     * @description Global key to be used when showing the Content Types functionality.
     */
    CONTENT_TYPES = 'GLOBAL.CONTENT_TYPES',
    /**
     * @value Contextual actions menu
     */
    CONTEXTUAL_ACTIONS_MENU = 'GLOBAL.CONTEXTUAL_ACTIONS_MENU',
    /**
     * @value Continue
     */
    CONTINUE = 'GLOBAL.CONTINUE',
    /**
     * @value Continue editing
     * @description Text to be displayed for an action that sends the user back to editing a certain entity
     */
    CONTINUE_EDITING = 'GLOBAL.CONTINUE_EDITING',
    /**
     * @value Continue in browser
     * @description Label of the button which lets the user resume his browsing in a web browser instead of switching to the mobile app
     */
    CONTINUE_IN_BROWSER = 'GLOBAL.CONTINUE_IN_BROWSER',
    /**
     * @value Copied to the clipboard
     * @description Success text to display when successfully copying something to the clipboard
     */
    COPIED = 'GLOBAL.COPIED',
    /**
     * @value Copy
     * @description Message to display when allowing the user to Copy something
     */
    COPY = 'GLOBAL.COPY',
    /**
     * @value Copy link
     * @description button label to copy a link to the clipboard
     */
    COPY_LINK = 'GLOBAL.COPY_LINK',
    /**
     * @value {"one":"%COUNT% Impression","other":"%COUNT% Impressions"}
     * @description An impression is the number of opportunities users have to view an element.
     */
    COUNT_IMPRESSION = 'GLOBAL.COUNT_IMPRESSION',
    /**
     * @value {"one":"%COUNT% COURSE","other":"%COUNT% COURSES"}
     */
    COURSE = 'GLOBAL.COURSE',
    /**
     * @value Coveo
     * @description coveo search engine name
     */
    COVEO = 'GLOBAL.COVEO',
    /**
     * @value Cover
     * @description To describe an image that will cover an area
     */
    COVER = 'GLOBAL.COVER',
    /**
     * @value Create
     * @description Text that can be used on a button allowing our users to create a new entity.
     */
    CREATE = 'GLOBAL.CREATE',
    /**
     * @value Created
     */
    CREATED = 'GLOBAL.CREATED',
    /**
     * @value Created at
     */
    CREATED_AT = 'CREATED_AT',
    /**
     * @value Created by
     */
    CREATED_BY = 'CREATED_BY',
    /**
     * @value Created date
     */
    CREATED_DATE = 'CREATED_DATE',
    /**
     * @value Created on
     * @description Tag detail about creation date
     */
    CREATED_ON = 'ADMIN.FOLKSONOMY.CREATED_THE',
    /**
     * @value Create & Edit
     */
    CREATE_AND_EDIT = 'ACTION_ADD_EDIT',
    /**
     * @value Create a publication
     * @description Call to action to create a publication
     */
    CREATE_A_PUBLICATION = 'GLOBAL.CREATE_A_PUBLICATION',
    /**
     * @value Create only
     * @description Permission that grants the user that receives it the right to create resources of a type, and only that. They cannot Edit or Delete this kind of resource, just create them
     */
    CREATE_ONLY = 'ACTION_CREATE',
    /**
     * @value Create with assistant
     * @description Label of a button to triger the opening of a chatbot to create something with the help of an AI assistant
     */
    CREATE_WITH_ASSISTANT = 'GLOBAL.CREATE_WITH_ASSISTANT',
    /**
     * @value Creation date
     */
    CREATION_DATE = 'CREATION_DATE',
    /**
     * @value Crop
     */
    CROP = 'CROP',
    /**
     * @value Adjust image framing
     * @description Title of the cropper dialog
     */
    CROPPER_DIALOG_TITLE = 'FRONT.CROPPER_DIALOG.TITLE',
    /**
     * @value The file contains %NB_ERRORS% errors. Correct them and replace the file.
     */
    CSV_ANALYSIS_ERROR_INTRO = 'GLOBAL.CSV_ANALYSIS_ERROR_INTRO',
    /**
     * @value Upload successfull: %NB_ROWS% rows and %NB_COLUMNS% columns
     */
    CSV_UPLOAD_SUCCESSFULL = 'GLOBAL.CSV_UPLOAD_SUCCESSFULL',
    /**
     * @value Generating...
     * @description Text to display on a transcript item when generation is in progress
     */
    CURRENTLY_GENERATING = 'PLAY.GENERATING',
    /**
     * @value Current site
     * @description Form choice or parameter value that allow to select current site only
     */
    CURRENT_SITE = 'GLOBAL.CURRENT_SITE',
    /**
     * @value Custom
     */
    CUSTOM = 'GLOBAL.CUSTOM',
    /**
     * @value Customer
     * @description A placeholder key that will be reused whenever we reference the word 'Customer' on its own.
     */
    CUSTOMER = 'GLOBAL.CUSTOMER',
    /**
     * @value Customer ID
     */
    CUSTOMER_ID = 'GLOBAL.CUSTOMER_ID',
    /**
     * @value Customize
     * @description Verb, short for "Customize email alias and prefix" or "Customize your profile". Usually as a title
     */
    CUSTOMIZE = 'GLOBAL.CUSTOMIZE',
    /**
     * @value Custom message
     */
    CUSTOM_MESSAGE = 'GLOBAL.CUSTOM_MESSAGE',
    /**
     * @value Dark
     */
    DARK = 'GLOBAL.DARK',
    /**
     * @value Dashboard
     * @description Single word "Dasboard"
     */
    DASHBOARD = 'GLOBAL.DASHBOARD',
    /**
     * @value Data sources
     */
    DATA_SOURCES = 'GLOBAL.DATA_SOURCES',
    /**
     * @value Date
     */
    DATE = 'DATE',
    /**
     * @value MMMM DD, YYYY
     * @description Format to use when displaying a date in full format including month day and year. it does not include minutes
     */
    DATE_FORMAT = 'DATE_FORMAT',
    /**
     * @value MMMM DD, YYYY [at] hh:mm a
     */
    DATE_FORMAT_COMPLETE = 'DATE_FORMAT_COMPLETE',
    /**
     * @value MMMM DD [at] hh:mm a
     */
    DATE_FORMAT_SHORT_COMPLETE = 'DATE_FORMAT_SHORT_COMPLETE',
    /**
     * @value From
     */
    DATE_FROM = 'DATE_FROM',
    /**
     * @value Date Picker
     * @description Label used for accessibility to describe the date picker dialog
     */
    DATE_PICKER = 'GLOBAL.DATE_PICKER',
    /**
     * @value Date Range
     */
    DATE_RANGE = 'ADMIN.SEARCH_ANALYTICS_DATE_RANGE_LABEL',
    /**
     * @value To
     */
    DATE_TO = 'DATE_TO',
    /**
     * @value day
     */
    DAY = 'GLOBAL.DAY',
    /**
     * @value Days
     */
    DAYS = 'GLOBAL.DAYS',
    /**
     * @value Deactivate
     * @description Useful when allowing the user to deactivate something
     */
    DEACTIVATE = 'GLOBAL.DEACTIVATE',
    /**
     * @value Deactivated
     */
    DEACTIVATED = 'GLOBAL.DEACTIVATED',
    /**
     * @value Decline
     * @description The label of the button used to decline the use of cookies, in the cookie banner.
     */
    DECLINE = 'FRONT.GDPR_BANNER.DECLINE',
    /**
     * @value Declined
     * @description Label used for accessibility purpose in order to display the event status for the current user when the event has been declined.
     */
    DECLINED = 'CALENDAR.EVENT_STATUS_DECLINED_ARIA_LABEL',
    /**
     * @value Default
     */
    DEFAULT = 'DEFAULT',
    /**
     * @value Default color
     */
    DEFAULT_COLOR = 'GLOBAL.DEFAULT_COLOR',
    /**
     * @value Default (%VALUE%)
     * @description Default (--Put default value here--)
     */
    DEFAULT_VALUE = 'GLOBAL.DEFAULT_VALUE',
    /**
     * @value Deletable
     */
    DELETABLE = 'CAN_PAGE_DELETE',
    /**
     * @value Delete
     * @description A placeholder key that will be reused whenever we reference the word 'Delete' on its own.
     */
    DELETE = 'GLOBAL.DELETE',
    /**
     * @value Deleted
     */
    DELETED = 'GLOBAL.DELETED',
    /**
     * @value Delete all
     * @description meant to be used globally but is used for instance as a menu option to delete all existing notifications
     */
    DELETE_ALL = 'GLOBAL.DELETE_ALL',
    /**
     * @value Delete category
     * @description Delete category action
     */
    DELETE_CATEGORY = 'COMMUNITIES.DELETE_CATEGORY',
    /**
     * @value Delete %ENTITY%
     * @description A generic deletion message that shows up in delete buttons for example.
     */
    DELETE_ENTITY = 'GLOBAL.DELETE_ENTITY',
    /**
     * @value Delete %ENTITY%?
     * @description A generic deletion message that shows up in confirmation dialogs for example.
     */
    DELETE_ENTITY_QUESTION = 'GLOBAL.DELETE_ENTITY_QUESTION',
    /**
     * @value Delete file
     */
    DELETE_FILE = 'GLOBAL.DELETE_FILE',
    /**
     * @value {"one":"Delete template","other":"Delete %NB% templates"}
     * @description Title and confirmation dialog for deleting a template.
     * For the singular, translate as in "Delete THE template" and not "delete A template", but omit "THE" if possible
     */
    DELETE_NB_TEMPLATES = 'GLOBAL.DELETE_NB_TEMPLATES',
    /**
     * @value Delete selected items
     */
    DELETE_SELECTED_ITEMS = 'ADMIN_DELETE_SELECTED_ITEMS',
    /**
     * @value Are you sure you want to delete selected items?
     */
    DELETE_SELECTED_ITEMS_DESCRIPTION = 'ADMIN_DELETE_SELECTED_ITEMS_DESCRIPTION',
    /**
     * @value An error occurred while deleted the selected items
     */
    DELETE_SELECTED_ITEMS_ERROR = 'ADMIN_DELETE_SELECTED_ITEMS_ERROR',
    /**
     * @value Selected items have been successfully deleted
     */
    DELETE_SELECTED_ITEMS_SUCCESS = 'ADMIN_DELETE_SELECTED_ITEMS_SUCCESS',
    /**
     * @value Delivered
     */
    DELIVERED = 'GLOBAL.DELIVERED',
    /**
     * @value Deployed
     * @description Deployed
     */
    DEPLOYED = 'GLOBAL.DEPLOYED',
    /**
     * @value Deploying
     */
    DEPLOYING = 'GLOBAL.DEPLOYING',
    /**
     * @value Deprecated
     * @description Deprecation warning on widget selection - Apply for all widgets
     */
    DEPRECATED = 'FRONT.DEPRECATION_WARNING.SELECTION.MESSAGE',
    /**
     * @value Help message is deprecated
     */
    DEPRECATED_HELP_MESSAGE = 'GLOBAL.DEPRECATED_HELP_MESSAGE',
    /**
     * @value Deprecated options
     */
    DEPRECATED_OPTIONS = 'GLOBAL.DEPRECATED_OPTIONS',
    /**
     * @value Descending
     */
    DESCENDING = 'FRONT.SETTINGS.DESCENDING_SORT_ORDER',
    /**
     * @value Description
     * @description Global key for the word "Description"
     */
    DESCRIPTION = 'GLOBAL.DESCRIPTION',
    /**
     * @value Description (%LANG%)
     * @description Global key for the word "Description" including the language in parenthesis
     */
    DESCRIPTION_WITH_LANG = 'GLOBAL.DESCRIPTION_WITH_LANG',
    /**
     * @value Designer
     * @description Designer
     */
    DESIGNER = 'GLOBAL.DESIGNER',
    /**
     * @value Details
     * @description Use to display details about something (label, action)
     */
    DETAILS = 'GLOBAL.DETAILS',
    /**
     * @value Desktop
     * @description Device name used in content preview to preview different device viewport (along side mobile, tablet & laptop)
     */
    DEVICES_DESKTOP = 'ANALYTICS.DEVICES_DESKTOP',
    /**
     * @value Laptop
     * @description Laptop device name used in content preview to preview different device viewport (along side desktop, tablet & mobile)
     */
    DEVICES_LAPTOP = 'GLOBAL.DEVICES_LAPTOP',
    /**
     * @value Mobile
     * @description Device name used in content preview to preview different device viewport (along side desktop, tablet & laptop)
     */
    DEVICES_MOBILE = 'ANALYTICS.DEVICES_MOBILE',
    /**
     * @value Tablet
     * @description Device name used in content preview to preview different device viewport (along side mobile, desktop & laptop)
     */
    DEVICES_TABLET = 'ANALYTICS.DEVICES_TABLET',
    /**
     * @value Digital Assistant
     */
    DIGITAL_ASSISTANT = 'ADMIN.ANALYTICS.DIGITAL_ASSISTANT_TAB',
    /**
     * @value Directories
     */
    DIRECTORIES = 'SEARCH_PLUS_DIRECTORY_TAB',
    /**
     * @value Directory
     */
    DIRECTORY = 'GLOBAL.DIRECTORY',
    /**
     * @value Directory entries
     * @description Name of the tab for directory entries dashboard
     */
    DIRECTORY_ENTRIES = 'ADMIN.ANALYTICS.DIRECTORY_ENTRIES_TAB',
    /**
     * @value Directory entry
     */
    DIRECTORY_ENTRY = 'ACTION_TYPE_DIRECTORY_ENTRY',
    /**
     * @value Favorites entries (directories)
     */
    DIRECTORY_ENTRY_FAVORITES = 'ACTION_TYPE_DIRECTORY_ENTRY_FAVORITES',
    /**
     * @value Disable
     */
    DISABLE = 'GLOBAL.DISABLE',
    /**
     * @value Disabled
     * @description Text to display when an entity is on status Disabled
     */
    DISABLED = 'GLOBAL.DISABLED',
    /**
     * @value Discard
     * @description Displayed in confirmation dialog when user needs to confirm Discarding a content
     */
    DISCARD = 'GLOBAL.DISCARD',
    /**
     * @value Discard changes
     * @description Displayed in confirmation dialog when user needs to confirm discarding changes made
     */
    DISCARD_CHANGES = 'GLOBAL.DISCARD_CHANGES',
    /**
     * @value Discard changes?
     * @description Text used to ask our users if they are sure they want to discard their changes.
     */
    DISCARD_CHANGES_CONFIRM = 'GLOBAL.DISCARD_CHANGES_CONFIRM',
    /**
     * @value Discard draft
     * @description Meant to be generic as a title for any situation where the user started a draft and is about to loose his edits.
     * Currently used as the title of the dialog used to ask the user to confirm wanting to cancel a new post creation even though he has already written something in his draft.
     * classic workflow:
     * The user edits an existing post or creates a new post.
     * He starts writing something but then clicks on CANCEL to close the new post / edit post dialog
     * A notification is displayed to ask the user if he really wants to loose his draft.
     * This key is for the title of that confirmation dialog.
     */
    DISCARD_DRAFT = 'GLOBAL.DISCARD_DRAFT',
    /**
     * @value Disconnect
     * @description Global text to be used across the platform in order to display an action that disconnects the user from a given service
     */
    DISCONNECT = 'GLOBAL.DISCONNECT',
    /**
     * @value Dismiss
     */
    DISMISS = 'GLOBAL.DISMISS',
    /**
     * @value Display
     */
    DISPLAY = 'GLOBAL.DISPLAY',
    /**
     * @value Display contextual actions menu
     * @description Used as an accessibility label (ARIA label) on the contextual action toggle button
     */
    DISPLAY_CONTEXTUAL_ACTIONS_MENU = 'GLOBAL.DISPLAY_CONTEXTUAL_ACTIONS_MENU',
    /**
     * @value Display more results
     * @description Text that should be used for showing an action that displays more results
     */
    DISPLAY_MORE_RESULTS = 'SEARCH_PLUS_SHOW_MORE',
    /**
     * @value Display only for languages
     */
    DISPLAY_ONLY_FOR_LANGUAGES = 'LANGUAGES.DISPLAY_ONLY_FOR_LANGUAGES',
    /**
     * @value Display %ENT%
     * @description Text to use to say that we want to display an element
     */
    DISPLAY_SOMETHING = 'GLOBAL.DISPLAY_SOMETHING',
    /**
     * @value Expand the window to allow display.
     * @description The description of the Display Unavailable state, which is displayed when the window is too small to display a content.
     */
    DISPLAY_UNAVAILABLE_STATE_DESCRIPTION = 'GLOBAL.DISPLAY_UNAVAILABLE_STATE_DESCRIPTION',
    /**
     * @value Display unavailable
     * @description The title of the Display Unavailable state, which is displayed when the window is too small to display a content.
     */
    DISPLAY_UNAVAILABLE_STATE_TITLE = 'GLOBAL.DISPLAY_UNAVAILABLE_STATE_TITLE',
    /**
     * @value Documentation
     * @description Display documentation label
     */
    DOCUMENTATION = 'GLOBAL.DOCUMENTATION',
    /**
     * @value Documents
     * @description Label for the Documents back-office page and its side navigation entry
     */
    DOCUMENTS = 'GLOBAL.DOCUMENTS',
    /**
     * @value Domain
     */
    DOMAIN = 'CONNECTORS.DOMAIN',
    /**
     * @value Done
     * @description Button text to click on when you have done your task. translate in the sense of "Finish" or "Finished"
     */
    DONE = 'GLOBAL.DONE',
    /**
     * @value Download
     * @description generic translation that can be used on buttons to download something
     */
    DOWNLOAD = 'GLOBAL.DOWNLOAD',
    /**
     * @value Download an example
     */
    DOWNLOAD_EXAMPLE = 'GLOBAL.DOWNLOAD_EXAMPLE',
    /**
     * @value Download File
     * @description Usage: text to be display on a button that will trigger a file download.
     *
     * @TODO: refactor this key in order to remove NANNY.
     */
    DOWNLOAD_FILE = 'ADMIN.NANNY.DOWNLOAD_FILE',
    /**
     * @value Download error log
     * @description URL link to download a file
     */
    DOWNLOAD_LOG = 'GLOBAL.DOWNLOAD_LOG',
    /**
     * @value Do not show this message again
     * @description Text display following a confirmation fo a user allowing to never display a specific message again, generally related to message that are always displayed after loading a page
     */
    DO_NOT_SHOW_THIS_MESSAGE_AGAIN = 'GLOBAL.DO_NOT_SHOW_THIS_MESSAGE_AGAIN',
    /**
     * @value Draft
     */
    DRAFT = 'GLOBAL.DRAFT',
    /**
     * @value Drafts
     * @description Drafts post, as work in progress.
     */
    DRAFTS = 'GLOBAL.DRAFTS',
    /**
     * @value {"one":"%COUNT% draft","other":"%COUNT% drafts"}
     * @description Draft contents  (like posts, articles)
     */
    DRAFT_COUNT_PLURALIZED = 'GLOBAL.DRAFT_COUNT_PLURALIZED',
    /**
     * @value Drag
     * @description Text to be displayed on an action that will drag an entity.
     */
    DRAG = 'GLOBAL.DRAG',
    /**
     * @value Movement cancelled. The item has returned to its starting position of %START_POSITION%
     * @description The use have cancelled the drag without changes.
     */
    DRAG_CANCELED = 'LUMX.DRAGGABLE.DRAG_CANCELED',
    /**
     * @value You have dropped the item. It has moved from position %START_POSITION% to %END_POSITION%.
     * @description The drag is ended, and the item has been moved.
     */
    DRAG_ENDED = 'LUMX.DRAGGABLE.DRAG_ENDED',
    /**
     * @value You have lifted an item in position %START_POSITION%.
     * @description The message announced when the user starts to drag an item
     */
    DRAG_STARTING = 'LUMX.DRAGGABLE.DRAG_STARTING',
    /**
     * @value You have moved the item from position %START_POSITION% to position %END_POSITION%.
     * @description The user have moved the dragged item to a new position.
     */
    DRAG_UPDATES = 'LUMX.DRAGGABLE.DRAG_UPDATES',
    /**
     * @value Drive
     * @description Text to be used when referencing the Drive service
     */
    DRIVE = 'GLOBAL.DRIVE',
    /**
     * @value Duplicate
     */
    DUPLICATE = 'GLOBAL.DUPLICATE',
    /**
     * @value Duration
     */
    DURATION = 'GLOBAL.DURATION',
    /**
     * @value d[d] h[h] m[m] s[s]
     * @description It's a duration conversion format, only translate what's in between "[ ]" :
     * d[first letter of "day"] h[first letter of "hour"] m[first letter of "minute"] s[first letter of "second"]
     */
    DURATION_FORMAT_DHMS = 'GLOBAL.DURATION_FORMAT_DHMS',
    /**
     * @value h[h] m[m] s[s]
     * @description It's a duration conversion format, only translate what's in between "[ ]".
     * h[first letter of "hour"] m[first letter of "minute"] s[first letter of "second"]
     */
    DURATION_FORMAT_HMS = 'GLOBAL.DURATION_FORMAT_HMS',
    /**
     * @value m[m] s[s]
     * @description It's a duration conversion format, only translate what's in between "[ ]".
     * m[first letter of "minute"] s[first letter of "second"]
     */
    DURATION_FORMAT_MS = 'GLOBAL.DURATION_FORMAT_MS',
    /**
     * @value s[s]
     * @description It's a duration conversion format, only translate what's in between "[ ]".
     * s[first letter of "second"]
     */
    DURATION_FORMAT_S = 'GLOBAL.DURATION_FORMAT_S',
    /**
     * @value Dynamic
     * @description Text used on the list widgets to choose the selection type
     */
    DYNAMIC = 'GLOBAL.DYNAMIC',
    D_M_YYYY = 'D-M-YYYY',
    /**
     * @value Edit
     * @description useful when allowing editing an entity
     */
    EDIT = 'GLOBAL.EDIT',
    /**
     * @value Editable
     */
    EDITABLE = 'CAN_PAGE_EDIT',
    /**
     * @value Editable by
     */
    EDITABLE_BY = 'CONTENT_SETTINGS_EDITABLE_BY',
    /**
     * @value Last edit on %DATE%
     * @description Used for displaying "edited at" date on a specific date.
     * Ex: Last edit on July 14, 2023
     */
    EDITED_AT_DATE = 'GLOBAL.EDITED_AT_DATE',
    /**
     * @value Editors
     */
    EDITORS = 'EDITOR_PLURAL',
    /**
     * @value Edit alt text
     * @description Text found on the button to edit the alternative text message on an image.
     */
    EDIT_ALT_TEXT = 'WREX_IMAGE.INSERT_ALT_TEXT_EDIT',
    /**
     * @value Edit details
     */
    EDIT_DETAILS = 'GLOBAL.EDIT_DETAILS',
    /**
     * @value Edit message
     */
    EDIT_MESSAGE = 'GLOBAL.EDIT_MESSAGE',
    /**
     * @value Edit options
     * @description Text used when selecting multiple items with a checkbox and wanting to editing all of them at once. (generally put in a button)
     */
    EDIT_OPTIONS = 'GLOBAL.EDIT_OPTIONS',
    /**
     * @value Edit profile
     */
    EDIT_PROFILE = 'GLOBAL.EDIT_PROFILE',
    /**
     * @value Edit source
     * @description Generic sentence when some source is being edited.
     */
    EDIT_SOURCE = 'GLOBAL.EDIT_SOURCE',
    /**
     * @value Email
     */
    EMAIL = 'GLOBAL.EMAIL',
    /**
     * @value Embed
     */
    EMBED = 'GLOBAL.EMBED',
    /**
     * @value Activities
     * @description Label used on the emoji picker for the emojis of the Activites category.
     */
    EMOJI_PICKER_ACTIVITY_CATEGORY = 'LUMX.EMOJI_PICKER_ACTIVITY_CATEGORY',
    /**
     * @value Animals & Nature
     * @description Label used on the emoji picker for the emojis of the Animals category.
     */
    EMOJI_PICKER_ANIMAL_CATEGORY = 'LUMX.EMOJI_PICKER_ANIMAL_CATEGORY',
    /**
     * @value Flags
     * @description Label used on the emoji picker for the emojis of the Flag category.
     */
    EMOJI_PICKER_FLAG_CATEGORY = 'LUMX.EMOJI_PICKER_FLAG_CATEGORY',
    /**
     * @value Food & Drink
     * @description Label used on the emoji picker for the emojis of the Food category.
     */
    EMOJI_PICKER_FOOD_CATEGORY = 'LUMX.EMOJI_PICKER_FOOD_CATEGORY',
    /**
     * @value Objects
     * @description Label used on the emoji picker for the emojis of the Object category.
     */
    EMOJI_PICKER_OBJECT_CATEGORY = 'LUMX.EMOJI_PICKER_OBJECT_CATEGORY',
    /**
     * @value Recently Used
     * @description Label used on the emoji picker for the emojis of the Recently used category.
     */
    EMOJI_PICKER_RECENT_CATEGORY = 'LUMX.EMOJI_PICKER_RECENT_CATEGORY',
    /**
     * @value Smileys & People
     * @description Label used on the emoji picker for the emojis of the Smiley category.
     */
    EMOJI_PICKER_SMILEY_CATEGORY = 'LUMX.EMOJI_PICKER_SMILEY_CATEGORY',
    /**
     * @value Symbols
     * @description Label used on the emoji picker for the emojis of the Symbol category.
     */
    EMOJI_PICKER_SYMBOL_CATEGORY = 'LUMX.EMOJI_PICKER_SYMBOL_CATEGORY',
    /**
     * @value Travel & Places
     * @description Label used on the emoji picker for the emojis of the Travel & Places category.
     */
    EMOJI_PICKER_TRAVEL_CATEGORY = 'LUMX.EMOJI_PICKER_TRAVEL_CATEGORY',
    /**
     * @value Empty
     * @description It's the verb! Used as a button's label when to want to empty a trash or a list for example
     */
    EMPTY_VERB = 'GLOBAL.EMPTY_VERB',
    /**
     * @value Enable
     */
    ENABLE = 'GLOBAL.ENABLE',
    /**
     * @value Enabled
     * @description Text to display when an entity is on status Enabled
     *
     */
    ENABLED = 'GLOBAL.ENABLED',
    /**
     * @value End date
     * @description Text displaying "End date"
     */
    END_DATE = 'END_DATE',
    /**
     * @value End time
     */
    END_TIME = 'END_TIME',
    /**
     * @value Enter a URL
     */
    ENTER_A_URL = 'ADMIN.TERMS_AND_CONDITIONS.REDIRECT_URL.PLACEHOLDER',
    /**
     * @value Enter your URL
     * @description Text used to ask the user to enter a url in an input text.
     */
    ENTER_URL = 'GLOBAL.ENTER_URL',
    /**
     * @value %ENTITY% moved to %TO%
     * @description Message to be displayed when successfully moving an entity from one place to another
     *
     * Params:
     * - ENTITY: entity moved
     * - TO: destination
     */
    ENTITY_MOVED = 'GLOBAL.ENTITY_MOVED',
    /**
     * @value %ENTITY_NAME%: %COUNT% removed.
     * @description Announced by screen readers when a form field automatically removes selected items due to a change in a related field (cascading update).
     *
     * %ENTITY_NAME% is the translated field name (e.g., “Content type”, “Tags”).
     * %COUNT% is the number of items removed.
     */
    ENTITY_REMOVED_COUNT_MESSAGE = 'GLOBAL.A11Y_ENTITY_REMOVED_COUNT_MESSAGE',
    /**
     * @value Error
     */
    ERROR = 'GLOBAL.ERROR',
    /**
     * @value Errors found in file
     * @description A message displayed when a csv upload as failed because the file contained some errors
     */
    ERRORS_IN_FILE = 'GLOBAL.ERRORS_IN_FILE',
    /**
     * @value An error occurred, the changes could not be saved
     * @description An error occurred, the changes could not be saved
     */
    ERROR_CHANGES_NOT_SAVED = 'GLOBAL.ERROR_CHANGES_NOT_SAVED',
    /**
     * @value Contrast ratio does not match accessibility standards.
     * @description Error message displayed when two colors contrast ratio doesn't match the accessibility standars.
     */
    ERROR_COLOR_CONTRAST_RATIO = 'GLOBAL.ERROR_COLOR_CONTRAST_RATIO',
    /**
     * @value Wrong file format
     */
    ERROR_FILE_FORMAT = 'GLOBAL.ERROR_FILE_FORMAT',
    /**
     * @value JSON file is invalid
     */
    ERROR_INVALID_JSON = 'GLOBAL.ERROR_INVALID_JSON',
    /**
     * @value Field is required
     * @description used when displaying an error message when a mandatory field was not completed
     */
    ERROR_MANDATORY_FIELD = 'GLOBAL.ERROR_MANDATORY_FIELD',
    /**
     * @value Not allowed
     */
    ERROR_NOT_AUTHORIZED = 'ERROR_NOT_AUTHORIZED',
    /**
     * @value An error occurred. Try again or come back later.
     */
    ERROR_OCCURRED_TRY_AGAIN = 'GLOBAL.ERROR_OCCURRED_TRY_AGAIN',
    /**
     * @value We're sorry but the web page you’re trying to visit might have been removed, had its name changed, or is temporarily unavailable.
     */
    ERROR_PAGE_404_DESCRIPTION = '404_DESCRIPTION',
    /**
     * @value Oops!
     */
    ERROR_PAGE_404_TITLE = '404_TITLE',
    /**
     * @value Please try again or contact your administrator
     */
    ERROR_PAGE_500_DESCRIPTION = '500_DESCRIPTION',
    /**
     * @value Oops, something went wrong
     */
    ERROR_PAGE_500_TITLE = '500_TITLE',
    /**
     * @value You do not have the required permissions to open this page.
     * @description Description on the restricted access error page of the designer app
     */
    ERROR_PAGE_RESTRICTED_ACCESS_DESCRIPTION = 'GLOBAL.ERROR_PAGE_RESTRICTED_ACCESS_DESCRIPTION',
    /**
     * @value You do not have access to this page
     * @description Title for the restricted access error page of the designer app
     */
    ERROR_PAGE_RESTRICTED_ACCESS_TITLE = 'GLOBAL.ERROR_PAGE_RESTRICTED_ACCESS_TITLE',
    /**
     * @value The page you are looking for may have been moved, renamed, or you may not have the required permission to access it.
     *
     * Try searching again, or return to the homepage to keep exploring.
     * @description Description of the "unavailable" error page
     */
    ERROR_PAGE_UNAVAILABLE_DESCRIPTION = 'GLOBAL.ERROR_PAGE_UNAVAILABLE_DESCRIPTION',
    /**
     * @value This page is unavailable
     * @description Title of the "unavailable" page
     */
    ERROR_PAGE_UNAVAILABLE_TITLE = 'GLOBAL.ERROR_PAGE_UNAVAILABLE_TITLE',
    /**
     * @value Url is not correct
     */
    ERROR_URL_BAD_FORMAT = 'ERROR_URL_BAD_FORMAT',
    /**
     * @value Error loading data, please try again.
     */
    ERROR_WHILE_FETCHING_DATA = 'SA_ANALYTICS_FETCH_DATA_RETRY_DESC',
    /**
     * @value Event
     */
    EVENT = 'GLOBAL.EVENT',
    /**
     * @value Events
     * @description Title of the option in the settings of a community
     */
    EVENTS = 'COMMUNITY_SETTINGS.EVENT_SERVICE_TITLE',
    /**
     * @value Everyone
     * @description Text that can be used as a select value to notify the user that a given entity is visible by everyone
     */
    EVERYONE = 'GLOBAL.EVERYONE',
    /**
     * @value Excerpt
     */
    EXCERPT = 'GLOBAL.EXCERPT',
    /**
     * @value Execute
     */
    EXECUTE = 'GLOBAL.EXECUTE',
    /**
     * @value Exit fullscreen
     */
    EXIT_FULLSCREEN = 'GLOBAL.EXIT_FULLSCREEN',
    /**
     * @value Expand
     * @description Global key used for describing an action that expands the current view. Like a button that when you click on it, the page that you are seeing expands
     */
    EXPAND = 'GLOBAL.EXPAND',
    /**
     * @value Expanded
     */
    EXPANDED = 'GLOBAL.EXPANDED',
    /**
     * @value Expiration
     */
    EXPIRATION = 'GLOBAL.EXPIRATION',
    /**
     * @value Expiration date
     */
    EXPIRATION_DATE = 'GLOBAL.EXPIRATION_DATE',
    /**
     * @value Expired
     * @description Status of a video when expired
     */
    EXPIRED = 'PLAY.VIDEO_STATUS_EXPIRED',
    /**
     * @value Expired on: %DATE%
     */
    EXPIRED_ON_DATE = 'CONTENT_ADMIN.EXPIRED_ON_DATE',
    /**
     * @value Expires on
     */
    EXPIRES_ON = 'GLOBAL.EXPIRES_ON',
    /**
     * @value Export
     * @description Export generic action
     */
    EXPORT = 'GLOBAL.EXPORT',
    /**
     * @value Export CSV
     * @description Generic export CSV action.
     */
    EXPORT_CSV = 'GLOBAL.EXPORT_CSV',
    /**
     * @value Extensions
     */
    EXTENSIONS = 'GLOBAL.EXTENSIONS',
    /**
     * @value External
     * @description External source for search settings
     */
    EXTERNAL = 'SEARCH_SETTINGS.EXTERNAL_SOURCE_TITLE',
    /**
     * @value External link
     * @description this is a basic entry for an external link as a menu item or a radio option for example
     * An external link is any url outside the LumApps platform, for example: https://www.ecosia.org
     */
    EXTERNAL_LINK = 'GLOBAL.EXTERNAL_LINK',
    /**
     * @value Failed to connect
     * @description Error status label shown after a connection test fails (e.g. next to a Test button).
     */
    FAILED_TO_CONNECT = 'GLOBAL.FAILED_TO_CONNECT',
    /**
     * @value Family name
     */
    FAMILY_NAME = 'GLOBAL.FAMILY_NAME',
    /**
     * @value Favorite sites
     * @description Favorite sites label, usually used with the icon on the top bar
     */
    FAVORITE_SITES = 'GLOBAL.FAVORITE_SITES',
    /**
     * @value Featured
     * @description label of a feature item
     */
    FEATURED = 'FRONT.SEARCH.RESULT_IS_FEATURED',
    /**
     * @value Featured image
     */
    FEATURED_IMAGE = 'WIDGET_TYPE_FEATURED-IMAGE_PLACEHOLDER',
    /**
     * @value Featured image toolbar
     */
    FEATURED_IMAGE_TOOLBAR = 'GLOBAL.FEATURED_IMAGE_TOOLBAR',
    /**
     * @value Features
     * @description Features
     */
    FEATURES = 'GLOBAL.FEATURES',
    /**
     * @value Feed
     * @description This is a part of the platform where users can see an aggregated stream of all their subscriptions. Take inspiration from Facebook on whether you should translate it or keep the english word
     */
    FEED = 'GLOBAL.FEED',
    /**
     * @value Groups
     * @description Single word "groups"
     */
    FEEDS = 'GLOBAL.FEEDS',
    /**
     * @value This field is required
     */
    FIELD_IS_REQUIRED = 'GLOBAL.FIELD_IS_REQUIRED',
    /**
     * @value {"one":"File","other":"Files"}
     */
    FILE = 'GLOBAL.FILE',
    /**
     * @value Files uploaded
     * @description Text used on an notification displayed when the user successfully uploaded more than one file at once (in post attachments, comment attachment...)
     */
    FILES_UPLOADED = 'GLOBAL.FILES_UPLOADED',
    /**
     * @value File analyzed
     */
    FILE_ANALYZED = 'GLOBAL.FILE_ANALYZED',
    /**
     * @value %FILE_EXTENSION% files are not supported
     * @description Message to display when a given file extension is not supported
     */
    FILE_EXTENSION_NOT_SUPPORTED = 'GLOBAL.FILE_EXTENSION_NOT_SUPPORTED',
    /**
     * @value File replaced
     * @description Text that can be used in a notification bar to inform the user that a file has been successfully replaced.
     */
    FILE_REPLACED = 'GLOBAL.FILE_REPLACED',
    /**
     * @value File uploaded
     * @description Text used on an notification displayed when the user successfully uploaded a file (in post attachments, comment attachment...)
     */
    FILE_UPLOADED = 'GLOBAL.FILE_UPLOADED',
    /**
     * @value Filter
     * @description Text to display on a button or an action that will filter a set of results
     */
    FILTER = 'GLOBAL.FILTER',
    /**
     * @value Filtering
     * @description Text used as a title in widget settings for the filtering section
     */
    FILTERING = 'GLOBAL.FILTERING',
    /**
     * @value Filters
     * @description Message to be displayed when showing a list of filters
     */
    FILTERS = 'GLOBAL.FILTERS',
    /**
     * @value Filter by
     * @description Message to display when showing a list of filters and letting the user know that they need to filter by something
     */
    FILTER_BY = 'GLOBAL.FILTER_BY',
    /**
     * @value Finish
     */
    FINISH = 'GLOBAL.FINISH',
    /**
     * @value Finished
     */
    FINISHED = 'GLOBAL.FINISHED',
    /**
     * @value First name
     */
    FIRST_NAME = 'GLOBAL.FIRST_NAME',
    /**
     * @value Flow
     */
    FLOW = 'GLOBAL.FLOW',
    /**
     * @value {"one":"Folder","other":"Folders"}
     */
    FOLDER = 'GLOBAL.FOLDER',
    /**
     * @value Follow
     * @description Global Follow key
     */
    FOLLOW = 'GLOBAL.FOLLOW',
    /**
     * @value Following
     * @description Key to be used when showing that an entity was Followed by the current user
     */
    FOLLOWED = 'GLOBAL.FOLLOWED',
    /**
     * @value Footer
     */
    FOOTER = 'FOOTER',
    /**
     * @value %KEY%: %VALUE%
     * @description Allows you to manage the ":" in a translation
     * ex: "Starting date: 2022-03-22"
     */
    FORMAT_COLON = 'GLOBAL.FORMAT_COLON',
    /**
     * @value Forms
     */
    FORMS = 'BOOKMARKED_MS_APPS_FORMS',
    /**
     * @value From
     * @description Used in context like:
     * Email will be sent tomorrow
     * From HR team
     * To everyone
     */
    FROM = 'GLOBAL.FROM',
    /**
     * @value Upload from computer
     */
    FROM_COMPUTER = 'GLOBAL.FROM_COMPUTER',
    /**
     * @value From device
     * @description Translation to use in media picker to upload a file from the current device
     */
    FROM_DEVICE = 'GLOBAL.FROM_DEVICE',
    /**
     * @value %FROM% to %TO%
     */
    FROM_TO = 'GLOBAL.FROM_TO',
    /**
     * @value Fullscreen
     */
    FULLSCREEN = 'GLOBAL.FULLSCREEN',
    /**
     * @value Fullscreen image
     * @description Name of the view displaying an image in full screen
     */
    FULLSCREEN_IMAGE = 'GLOBAL.FULLSCREEN_IMAGE',
    /**
     * @value Fullscreen image slideshow
     * @description Name of the view displaying an image slideshow in full screen
     */
    FULLSCREEN_IMAGE_SLIDESHOW = 'GLOBAL.FULLSCREEN_IMAGE_SLIDESHOW',
    /**
     * @value Full name
     */
    FULL_NAME = 'FRONT.USER_DIRECTORY.FULL_NAME',
    /**
     * @value General
     * @description Single word "General"
     */
    GENERAL = 'GLOBAL.GENERAL',
    /**
     * @value General settings
     */
    GENERAL_SETTINGS = 'ADMIN.NAV.MOBILE_GENERAL_SETTINGS',
    /**
     * @value Generate
     * @description Text used to label a button allowing the user to trigger an action that will generate a new resource.
     */
    GENERATE = 'GLOBAL.GENERATE',
    /**
     * @value An error occurred
     * @description used when displaying an generic error, normally displayed using a notification on the bottom right corner of the screen.
     */
    GENERIC_ERROR = 'GLOBAL.ERROR.GENERIC',
    /**
     * @value Get
     */
    GET = 'GLOBAL.GET',
    /**
     * @value Given name
     */
    GIVEN_NAME = 'GLOBAL.GIVEN_NAME',
    /**
     * @value Global instructions
     */
    GLOBAL_INSTRUCTIONS = 'GLOBAL.GLOBAL_INSTRUCTIONS',
    /**
     * @value Global settings
     */
    GLOBAL_SETTINGS = 'ADMIN.ADVANCED_SETTINGS.DEFAULT_CATEGORY',
    /**
     * @value Global Widget
     */
    GLOBAL_WIDGET = 'ACTION_TYPE_GLOBAL_WIDGET',
    /**
     * @value Google
     */
    GOOGLE = 'ADMIN_RESELLER_CONSOLE_TAB_GOOGLE',
    /**
     * @value Google Analytics
     */
    GOOGLE_ANALYTICS = 'GLOBAL.GOOGLE_ANALYTICS',
    /**
     * @value Shared Drive
     * @description Google product "Team Drive" has been rebranded to "Shared Drive"
     */
    GOOGLE_TEAM_DRIVE = 'GLOBAL.GOOGLE_TEAM_DRIVE',
    /**
     * @value Go back
     * @description Displayed in dialog where an option offers to go back to editing a content
     */
    GO_BACK = 'GLOBAL.GO_BACK',
    /**
     * @value Go to the home page
     * @description Text to display as a tooltip for the Site's logo
     */
    GO_TO_HOMEPAGE = 'FRONT.GO_HOMEPAGE',
    /**
     * @value Grant type
     */
    GRANT_TYPE = 'CONNECTORS.GRANT_TYPE',
    /**
     * @value {"one":"Group","other":"Groups"}
     * @description Group as in a group of people
     */
    GROUP = 'GLOBAL.GROUP',
    /**
     * @value {"one":"%COUNT% group","other":"%COUNT% groups"}
     * @description Number of groups, e.g in a community
     *
     * Parameters:
     * - Count: group total
     */
    GROUPS_COUNT = 'GLOBAL.GROUPS_COUNT',
    /**
     * @value Group name
     */
    GROUP_NAME = 'GLOBAL.GROUP_NAME',
    /**
     * @value Hello %USERNAME%!
     */
    HELLO_USERNAME = 'GLOBAL.HELLO_USERNAME',
    /**
     * @value Helpful
     */
    HELPFUL = 'GLOBAL.HELPFUL',
    /**
     * @value The color value has to respect the hexadecimal format: #xxxxxx
     */
    HEXADECIMAL_COLOR_ERROR = 'GLOBAL.HEXADECIMAL_COLOR_ERROR',
    /**
     * @value Hidden
     */
    HIDDEN = 'GLOBAL.HIDDEN',
    /**
     * @value Hide
     */
    HIDE = 'HIDE',
    /**
     * @value Hide advanced settings
     */
    HIDE_ADVANCED_SETTINGS = 'GLOBAL.HIDE_ADVANCED_SETTINGS',
    /**
     * @value Hide contextual actions menu
     * @description Used as an accessibility label (ARIA label) on the contextual action toggle button
     */
    HIDE_CONTEXTUAL_ACTIONS_MENU = 'GLOBAL.HIDE_CONTEXTUAL_ACTIONS_MENU',
    /**
     * @value Hide filters
     * @description action to hide filters from the search page
     */
    HIDE_FILTERS = 'FRONT.SEARCH.HIDE_FILTERS',
    /**
     * @value Hide message
     * @description Label that is used in context where we need to hide a message
     */
    HIDE_MESSAGE = 'GLOBAL.HIDE_MESSAGE',
    /**
     * @value Highlighted for
     * @description Number of user higlighted on the given content (site page).
     */
    HIGHLIGHTED_FOR = 'LOOKER_CONTENT_HIGHLIGHTED_FOR',
    /**
     * @value History
     */
    HISTORY = 'SOCIAL_PROFILE_HISTORY',
    /**
     * @value Home
     * @description Title of the feature "Home" when activating it in the mobile configuration and placing it in the mobile configuration "designer" tab.
     * We don't want to call it "homepage" —it's specifically "Home".
     */
    HOME = 'ADMIN.MOBILE.HOME.FEATURE_NAME',
    /**
     * @value Homepage
     */
    HOMEPAGE = 'FRONT.COMMUNITY.DASHBOARD',
    /**
     * @value %SITE%'s home page
     * @description Text used to reference a site's home page.
     *
     * Parameters:
     * - SITE: site's name
     */
    HOME_PAGE = 'GLOBAL.HOME_PAGE',
    /**
     * @value {"one":"%COUNT% hour","other":"%COUNT% hours"}
     */
    HOUR = 'GLOBAL.HOUR',
    /**
     * @value How it works
     */
    HOW_IT_WORKS = 'GLOBAL.HOW_IT_WORKS',
    /**
     * @value Icon
     */
    ICON = 'GLOBAL.ICON',
    /**
     * @value ID
     * @description Text to be used for displaying an ID of an entity
     */
    ID = 'GLOBAL.ID',
    /**
     * @value Identifier
     */
    IDENTIFIER = 'ADMIN.COMMUNITY.SETUP.FIELD.CHAT.CHANNEL.ID',
    /**
     * @value Ignore
     */
    IGNORE = 'WREX_AI.IGNORE_SUGGESTION',
    /**
     * @value {"one":"Image","other":"Images"}
     */
    IMAGE = 'GLOBAL.IMAGE',
    /**
     * @value Images uploaded
     * @description Text used on an notification displayed when the user successfully uploaded more than one images (in post inline image...)
     */
    IMAGES_UPLOADED = 'GLOBAL.IMAGES_UPLOADED',
    /**
     * @value Image uploaded
     * @description Text used on an notification displayed when the user successfully uploaded an image (in post inline image...)
     */
    IMAGE_UPLOADED = 'GLOBAL.IMAGE_UPLOADED',
    /**
     * @value Immediately
     */
    IMMEDIATELY = 'GLOBAL.IMMEDIATELY',
    /**
     * @value Import
     * @description Text to be used on an action that will import an entity
     */
    IMPORT = 'GLOBAL.IMPORT',
    /**
     * @value In
     * @description Text used for displaying where something belongs to. For example, that a post was posted "In" a certain community
     */
    IN = 'GLOBAL.IN',
    /**
     * @value Inactive
     */
    INACTIVE = 'SA_SOCIAL_NETWORK_NOT_ACTIVE',
    /**
     * @value Incomplete translation
     * @description Used as the title of a toggletip (= a button with some text displayed on hover, clicking it will open a popover with more details) to let the user know that the matching translation have not been completed yet.
     */
    INCOMPLETE_TRANSLATION = 'GLOBAL.INCOMPLETE_TRANSLATION',
    /**
     * @value {"one":"Recipients using this language will only see the parts that have been translated.","other":"Recipients using these languages will only see the parts that have been translated."}
     */
    INCOMPLETE_TRANSLATIONS_DETAIL_1 = 'GLOBAL.INCOMPLETE_TRANSLATIONS_DETAIL_1',
    /**
     * @value Any untranslated content will appear in the source language.
     */
    INCOMPLETE_TRANSLATIONS_DETAIL_2 = 'GLOBAL.INCOMPLETE_TRANSLATIONS_DETAIL_2',
    /**
     * @value Some translations are incomplete:
     * @description It is followed by a list of languages on bullet points (like English, Russian...)
     */
    INCOMPLETE_TRANSLATIONS_LIST = 'GLOBAL.INCOMPLETE_TRANSLATIONS_LIST',
    /**
     * @value Start time must be before end time
     * @description Error message in case the start time set in the first input is after the end time in the second input
     */
    INCORRECT_TIME_START_AFTER_END = 'GLOBAL.INCORRECT_TIME_START_AFTER_END',
    /**
     * @value Starting and ending time must not be the same
     */
    INCORRECT_TIME_START_EQUAL_END = 'EVENTS.INCORRECT_TIME_START_EQUAL_END',
    /**
     * @value Information
     * @description Button or menu entry to get information on a component
     */
    INFORMATION = 'GLOBAL.INFORMATION',
    /**
     * @value Insert
     * @description Text to display when inserting something into list
     */
    INSERT = 'GLOBAL.INSERT',
    /**
     * @value Attach video
     * @description In post dialog, the tooltip displayed when hovering the video button
     */
    INSERT_VIDEO = 'FRONT.ATTACHMENTS.ADD_VIDEO',
    /**
     * @value Insights
     * @description insights section title
     */
    INSIGHTS = 'ADMIN.FOLKSONOMY.INSIGHTS',
    /**
     * @value Integration
     * @description Text that can be used as the title of a section where the user can manage where a given entity will be embedded (is my entity publied in this content type or not?, etc…)
     */
    INTEGRATION = 'GLOBAL.INTEGRATION',
    /**
     * @value Integrations
     */
    INTEGRATIONS = 'NATIVE_INTEGRATIONS',
    /**
     * @value Internal
     */
    INTERNAL = 'GLOBAL.INTERNAL',
    /**
     * @value Invalid email
     */
    INVALID_EMAIL = 'SERVER_ERROR_INVALID_EMAIL',
    /**
     * @value This field is invalid.
     * @description Global message to use when a field is invalid
     */
    INVALID_FIELD = 'GLOBAL.INVALID_FIELD',
    /**
     * @value Invalid Key
     */
    INVALID_KEY = 'CONNECTORS.INVALID_KEY',
    /**
     * @value In progress
     */
    IN_PROGRESS = 'GLOBAL.IN_PROGRESS',
    /**
     * @value In %VALUE%
     * @description Used to show in what something is included. Example: this broadcast "in" that campaign
     */
    IN_VALUE = 'GLOBAL.IN_VALUE',
    /**
     * @value {"one":"is","other":"are"}
     * @description the verb "to be" at the third person
     * "Group is..."
     * "Communities are..."
     */
    IS = 'GLOBAL.IS',
    /**
     * @value "%TAG%" is already added
     * @description Message display if current tag is already added
     */
    IS_ALREADY_ADDED = 'FRONT.TAGZ.ALREADY_ADDED',
    /**
     * @value Is empty
     * @description Text used on filters to filter items in the list where specific value is empty
     */
    IS_EMPTY = 'GLOBAL.IS_EMPTY',
    /**
     * @value Journeys
     * @description Title of the "journeys" section and page
     *
     * "Journeys" is a product name, it should not be translated
     */
    JOURNEYS = 'JOURNEY_ADMIN.JOURNEYS',
    /**
     * @value Jump to
     * @description Label of a button that open a calendar, in order to "jump to" a specific date in a timeline
     */
    JUMP_TO = 'GLOBAL.JUMP_TO',
    /**
     * @value Keep
     * @description Text used to label a button allowing the user to not delete a resource and keep it instead.
     */
    KEEP = 'GLOBAL.KEEP',
    /**
     * @value Keep as is
     * @description Option to indicate that no changes should be applied for the current field, but keep the existing value.
     */
    KEEP_AS_IS = 'GLOBAL.KEEP_AS_IS',
    /**
     * @value Keep editing
     */
    KEEP_EDITING = 'GLOBAL.KEEP_EDITING',
    /**
     * @value Key
     */
    KEY = 'GLOBAL.KEY',
    /**
     * @value Keyword
     */
    KEYWORD = 'WIDGET_TYPE_CONTENT-FILTER_QUERY',
    /**
     * @value Knowledge
     * @description Knowledge topic title
     */
    KNOWLEDGE = 'MARKETPLACE.EXTENSIONS_TOPIC_KNOWLEDGE',
    /**
     * @value Learn more
     * @description Text that triggers an action to learn more about the displayed content
     */
    KNOW_MORE = 'KNOW_MORE',
    /**
     * @value Label
     * @description Single word "Label"
     */
    LABEL = 'GLOBAL.LABEL',
    /**
     * Label (English)
     * @value Label (%LANG%)
     */
    LABEL_LOCALIZED = 'GLOBAL.LABEL_LOCALIZED',
    /**
     * @value Language
     */
    LANGUAGE = 'FRONT.PROCESS_MAKER.LANGUAGE',
    /**
     * @value Languages
     */
    LANGUAGES = 'ADMIN_INSTANCE_LANGS',
    /**
     * @value {"one":"%NB% language","other":"%NB% languages"}
     * @description Text used to display the number of languages selected
     * e.g "5 languages"
     */
    LANGUAGES_NUMBER = 'GLOBAL.LANGUAGES_NUMBER',
    /**
     * @value Choose language.
     * @description Aria-label for the button opening the dropdown of quick language selection.
     */
    LANGUAGE_SWITCHER_ARIA_LABEL = 'FRONT.LANGUAGE_SWITCHER.ARIA_LABEL',
    /**
     * @value Last calculated on %DATE%
     */
    LAST_CALCULATED_ON = 'GLOBAL.LAST_CALCULATED_ON',
    /**
     * @value Last deployment
     */
    LAST_DEPLOYMENT = 'GLOBAL.LAST_DEPLOYMENT',
    /**
     * @value Last modified on %DATE%
     * @description Text to be used to show when was an entity last modified on.
     *
     * Parameters:
     * - DATE: specific modification date
     */
    LAST_MODIFIED_ON = 'GLOBAL.LAST_MODIFIED_ON',
    /**
     * @value Last name
     */
    LAST_NAME = 'ADMIN_FILTER_LAST_NAME',
    /**
     * @value Last update
     * @description date of the last update of a content or a community or a post or any other thing that can be updated.
     */
    LAST_UPDATE = 'GLOBAL.LAST_UPDATE',
    /**
     * @value Last update date
     */
    LAST_UPDATED_DATE = 'WIDGET_TYPE_CONTENT-LIST_UPDATED-DATE',
    /**
     * @value Last updated on
     */
    LAST_UPDATED_ON = 'LAST_UPDATED_ON',
    /**
     * @value Last updated on %DATE%
     * @description Text to display the last date a resource has been updated
     */
    LAST_UPDATED_ON_DATE = 'GLOBAL.LAST_UPDATED_ON_DATE',
    /**
     * @value Last used
     */
    LAST_USED = 'GLOBAL.LAST_USED',
    /**
     * @value Latest
     */
    LATEST = 'GLOBAL.LATEST',
    /**
     * @value Latest to oldest
     * @description Text used to sort items from latest to oldest
     */
    LATEST_TO_OLDEST = 'GLOBAL.LATEST_TO_OLDEST',
    /**
     * @value Learners
     */
    LEARNERS = 'GLOBAL.LEARNERS',
    /**
     * @value Learning
     * @description Type of training
     */
    LEARNING = 'GLOBAL.LEARNING',
    /**
     * @value Learn more
     */
    LEARN_MORE = 'GLOBAL.LEARN_MORE',
    /**
     * @value Least recent activity
     * @description Sort option in a sorting button in order to sort between most recent activity and least recent activity
     */
    LEAST_RECENT_ACTIVITY = 'GLOBAL.LEAST_RECENT_ACTIVITY',
    /**
     * @value Leave
     */
    LEAVE = 'GLOBAL.LEAVE',
    /**
     * @value Leave without saving?
     * @description Question that demands confirmation from the user before leaving a page
     */
    LEAVE_WITHOUT_SAVING = 'GLOBAL.LEAVE_WITHOUT_SAVING',
    /**
     * @value Less
     */
    LESS = 'GLOBAL.LESS',
    /**
     * @value Less filters
     */
    LESS_FILTERS = 'GLOBAL.LESS_FILTERS',
    /**
     * @value Less settings
     * @description A link or button for the user to click to collapse the list of settings that was previously expanded
     */
    LESS_SETTINGS = 'GLOBAL.LESS_SETTINGS',
    /**
     * @value Library
     */
    LIBRARY = 'GLOBAL.LIBRARY',
    /**
     * @value Light
     */
    LIGHT = 'STYLE.FONT.LIGHT',
    /**
     * @value like
     */
    LIKE = 'LIKE_BUTTON_LABEL',
    /**
     * @value likes
     */
    LIKES = 'LIKE_BUTTON_LABEL_PLURAL',
    LIKE_PLURALIZE = 'GLOBAL.LIKE_PLURALIZE',
    /**
     * @value Limited
     */
    LIMITED = 'GLOBAL.LIMITED',
    /**
     * @value Line %LINE_NB%: %MESSAGE%
     */
    LINE_ERROR = 'GLOBAL.LINE_ERROR',
    /**
     * @value Link
     * @description Used everywhere where the word link is needed (url label,...etc)
     */
    LINK = 'GLOBAL.LINK',
    /**
     * @value Link copied to the clipboard
     */
    LINK_COPIED = 'FRONT.MEDIA_PICKER.LINK_COPIED',
    /**
     * @value Link preview
     * @description Text used on article / event editor to add a link preview
     */
    LINK_PREVIEW = 'GLOBAL.LINK_PREVIEW',
    /**
     * @value Link to copy
     * @description Label title for the CategoryShareDialog component
     */
    LINK_TO_COPY = 'GLOBAL.LINK_TO_COPY',
    /**
     * @value Live
     */
    LIVE = 'GLOBAL.LIVE',
    /**
     * @value Loading
     * @description Generic loading text
     */
    LOADING = 'GLOBAL.LOADING',
    /**
     * @value Location
     */
    LOCATION = 'FRONT.EVENT.DIALOG.LOCATION_LABEL',
    /**
     * @value Lock
     * @description Label for the icon button that locks a group of linked inputs
     */
    LOCK = 'GLOBAL.LOCK',
    /**
     * @value Logged in
     */
    LOGGED_IN = 'GLOBAL.LOGGED_IN',
    /**
     * @value Log in
     */
    LOG_IN = 'GLOBAL.LOG_IN',
    /**
     * @value LumApps
     * @description Text to be used when referencing the LumApps service
     */
    LUMAPPS = 'GLOBAL.LUMAPPS',
    /**
     * @value Play
     * @description The LumApps Play product name. Must never be translated — always rendered as
     * "Play" regardless of interface language.
     */
    LUMAPPS_PLAY = 'GLOBAL.LUMAPPS_PLAY',
    /**
     * @value Lumwork
     * @description Text to be used when referencing the LumWork service
     */
    LUMWORK = 'SEARCH_PLUS_LUMWORK_TAB',
    /**
     * @value Main details
     * @description Title of the global overview step when running the learning agent's flow
     */
    MAIN_DETAILS = 'GLOBAL.MAIN_DETAILS',
    /**
     * @value Manage
     */
    MANAGE = 'GLOBAL.MANAGE',
    /**
     * @value Manager
     * @description Label/title/role of the manager of a community, a group...
     */
    MANAGER = 'GLOBAL.MANAGER',
    /**
     * @value Managers
     * @description label for the space manager picker to ask the user to add a new one
     * The term "Space" must not be translated, it is a male name.
     *
     */
    MANAGERS = 'SPACES.MANAGERS',
    /**
     * @value Manage translations
     */
    MANAGE_TRANSLATIONS = 'LANGUAGES.MANAGE_TRANSLATIONS',
    /**
     * @value Mandatory
     */
    MANDATORY = 'GLOBAL.MANDATORY',
    /**
     * @value Manual
     * @description Text used on the list widgets to choose the selection type
     */
    MANUAL = 'GLOBAL.MANUAL',
    /**
     * @value Mark as attended
     */
    MARK_AS_ATTENDED = 'GLOBAL.MARK_AS_ATTENDED',
    /**
     * @value Maximum size exceeded
     */
    MAXIMUM_SIZE_EXCEEDED = 'MICROAPP.MAXIMUM_SIZE_EXCEEDED',
    /**
     * @value File size must not exceed %FILE_SIZE% MB.
     * @description Uploader component helper indicating the maximum size a file can have
     */
    MAX_FILE_SIZE = 'MICRO_APP_INTEGRATIONS.MAX_FILE_SIZE',
    /**
     * @value If no value it defaults to %NB% elements.
     */
    MAX_RESULTS_NUMBER_HELP = 'GLOBAL.MAX_RESULTS_NUMBER_HELP',
    /**
     * @value Media
     * @description A placeholder key that will be reused whenever we reference the word 'Media' on its own.
     */
    MEDIA = 'GLOBAL.MEDIA',
    /**
     * @value Media library
     */
    MEDIA_LIBRARY = 'GLOBAL.MEDIA_LIBRARY',
    /**
     * @value Member
     * @description Label/title/role of the member of a community, a group...
     */
    MEMBER = 'GLOBAL.MEMBER',
    /**
     * @value Message
     */
    MESSAGE = 'GLOBAL.MESSAGE',
    /**
     * @value Additional message to requester
     */
    MESSAGE_TO_REQUESTER = 'GLOBAL.MESSAGE_TO_REQUESTER',
    /**
     * @value Metadata
     */
    METADATA = 'WIDGET_TYPE_CONTENT-LIST_METADATA',
    /**
     * @value Microsoft
     */
    MICROSOFT = 'GLOBAL.MICROSOFT',
    /**
     * @value Micro-app
     * @description Type microapp for marketplace extensions
     */
    MICRO_APP = 'MARKETPLACE.EXTENSION_TYPE_MICRO_APP',
    /**
     * @value Micro-Apps
     * @description The main title of an analytics dashboard.
     */
    MICRO_APPS = 'LOOKER_PLATFORM_MICROAPPS_DASHBOARD_MAIN_TITLE',
    /**
     * @value %COUNT% minutes
     */
    MINUTES = 'GLOBAL.MINUTES',
    /**
     * @value Mission
     * @description "Mission" single word
     */
    MISSION = 'GLOBAL.MISSION',
    /**
     * @value Mobile
     */
    MOBILE = 'GLOBAL.MOBILE',
    /**
     * @value Mobile Course
     * @description Title for learning activity of type course
     */
    MOBILE_COURSE = 'GLOBAL.MOBILE_COURSE',
    /**
     * @value Mobile navigation
     */
    MOBILE_NAVIGATION = 'GLOBAL.MOBILE_NAVIGATION',
    /**
     * @value Push
     * @description Here the "push" word refers to the "Mobile push notification" term.
     *
     * The translated word should be "short", since it will be displayed in a small button
     */
    MOBILE_PUSH = 'GLOBAL.MOBILE_PUSH',
    /**
     * @value Modifications saved
     */
    MODIFICATIONS_SAVED = 'GLOBAL.MODIFICATIONS_SAVED',
    /**
     * @value Modify
     * @description action to modify something
     */
    MODIFY = 'GLOBAL.MODIFY',
    /**
     * @value month
     * @description Used to be concatenated in other translations
     */
    MONTH = 'GLOBAL.MONTH',
    /**
     * @value months
     */
    MONTHS = 'GLOBAL.MONTHS',
    /**
     * @value More
     * @description Text to display the word "More"
     */
    MORE = 'GLOBAL.MORE',
    /**
     * @value More actions
     */
    MORE_ACTIONS = 'GLOBAL.MORE_ACTIONS',
    /**
     * @value More filters
     * @description Message to be displayed when showing an option to show more filters
     */
    MORE_FILTERS = 'GLOBAL.MORE_FILTERS',
    /**
     * @value More information
     */
    MORE_INFORMATION = 'FRONT.USER.PROFILE.MORE_INFO.LINK',
    /**
     * @value More options
     * @description Prompt to show more options
     */
    MORE_OPTIONS = 'GLOBAL.MORE_OPTIONS',
    /**
     * @value More results
     * @description Text to display "More results"
     */
    MORE_RESULTS = 'GLOBAL.MORE_RESULTS',
    /**
     * @value More settings
     * @description A link or button for the user to click to display more settings
     */
    MORE_SETTINGS = 'GLOBAL.MORE_SETTINGS',
    /**
     * @value Mosaic
     */
    MOSAIC = 'GLOBAL.MOSAIC',
    /**
     * @value Most recent
     * @description Most recent text, mostly displayed as a sorting option
     */
    MOST_RECENT = 'GLOBAL.MOST_RECENT',
    /**
     * @value Most recent activity
     */
    MOST_RECENT_ACTIVITY = 'GLOBAL.MOST_RECENT_ACTIVITY',
    /**
     * @value Most Relevant
     * @description sort most relevant item first
     */
    MOST_RELEVANT = 'GLOBAL.MOST_RELEVANT',
    /**
     * @value Move
     */
    MOVE = 'GLOBAL.MOVE',
    /**
     * @value Moved
     * @description Information message for when an element has been moved successfully.
     */
    MOVED = 'GLOBAL.MOVED',
    /**
     * @value Move down
     * @description Text used to display an action that will move down an entity in a list
     */
    MOVE_DOWN = 'GLOBAL.MOVE_DOWN',
    /**
     * @value Move here
     * @description Text to display on an action that will move an entity to the current displayed context
     */
    MOVE_HERE = 'GLOBAL.MOVE_HERE',
    /**
     * @value Move %ENT%
     * @description Text to display on an action that will move an named entity elsewhere
     */
    MOVE_SOMETHING = 'GLOBAL.MOVE_SOMETHING',
    /**
     * @value Move to
     */
    MOVE_TO = 'FRONT.MEDIA_PICKER.MOVE_TO',
    /**
     * @value Move to bottom
     * @description Text used when the action will move an item from a list to the bottom of this list
     */
    MOVE_TO_BOTTOM = 'GLOBAL.MOVE_TO_BOTTOM',
    /**
     * @value Move to top
     * @description Text used when the action will move an item from a list to the top of this list
     */
    MOVE_TO_TOP = 'GLOBAL.MOVE_TO_TOP',
    /**
     * @value Move up
     * @description Text used to display an action that will move up an entity in a list.
     */
    MOVE_UP = 'GLOBAL.MOVE_UP',
    /**
     * @value Name
     */
    NAME = 'GLOBAL.NAME',
    /**
     * @value Native Search
     */
    NATIVE_SEARCH = 'GLOBAL.NATIVE_SEARCH',
    /**
     * @value Navigate
     * @description Simple "Navigate" word
     */
    NAVIGATE = 'GLOBAL.NAVIGATE',
    /**
     * @value Navigated to "%PAGE_TITLE%"
     * @description Announcement made to screen readers when a navigation to a new page occurs.
     */
    NAVIGATED_TO_PAGE = 'GLOBAL.NAVIGATED_TO_PAGE',
    /**
     * @value Navigation
     * @description Title of the mobile navigation administration
     */
    NAVIGATION = 'ADMIN.MOBILE.NAVIGATION.TITLE',
    /**
     * @value {"one":"1 option available","other":"%NB% options available"}
     * @description Text to describe the number of available options.
     */
    NB_OPTIONS_AVAILABLE = 'GLOBAL.NB_OPTIONS_AVAILABLE',
    /**
     * @value {"one":"%NB% person","other":"%NB% people"}
     */
    NB_PEOPLE = 'GLOBAL.NB_PEOPLE',
    /**
     * @value {"one":"%NB% remaining","other":"%NB% remaining"}
     * @description Generic count-remaining label.
     * %NB% is replaced at runtime with a number (e.g., "5 remaining", "1 remaining"). Used generically wherever we need to show how many of something is left (items, credits, attempts, etc.).
     *
     * Please handle singular/plural forms ("one", "two", "few", "other")
     */
    NB_REMAINING = 'GLOBAL.NB_REMAINING',
    /**
     * @value {"one":"%NB% result","other":"%NB% results"}
     */
    NB_RESULTS = 'GLOBAL.NB_RESULTS',
    /**
     * @value {"one":"1 result displayed","other":"%NB% results displayed"}
     * @description Message to read how many results is currently displayed.
     * Can be used to announce to screen readers the current status of a search.
     */
    NB_RESULTS_DISPLAYED = 'GLOBAL.NB_RESULTS_DISPLAYED',
    /**
     * @value {"one":"1 result displayed for %QUERY%","other":"%NB% results displayed for %QUERY%"}
     * @description Message to read how many results is currently displayed for a given query.
     * Can be used to announce to screen readers the current status of a search.
     */
    NB_RESULTS_DISPLAYED_FOR_QUERY = 'GLOBAL.NB_RESULTS_DISPLAYED_FOR_QUERY',
    /**
     * @value {"one":"1 result displayed out of %TOTAL%","other":"%NB% results displayed out of %TOTAL%"}
     * @description Message to read how many results is currently displayed for a given query.
     * Can be used to announce to screen readers the current status of a search.
     */
    NB_RESULTS_DISPLAYED_OUT_OF_TOTAL = 'GLOBAL.NB_RESULTS_DISPLAYED_OUT_OF_TOTAL',
    /**
     * @value {"one":"1 result displayed out of %TOTAL% for %QUERY%","other":"%NB% results displayed out of %TOTAL% for %QUERY%"}
     * @description Message to read how many results is currently displayed for a given query.
     * Can be used to announce to screen readers the current status of a search.
     */
    NB_RESULTS_DISPLAYED_OUT_OF_TOTAL_FOR_QUERY = 'GLOBAL.NB_RESULTS_DISPLAYED_OUT_OF_TOTAL_FOR_QUERY',
    /**
     * @value {"one":"%NB% video","other":"%NB% videos"}
     */
    NB_VIDEOS = 'GLOBAL.NB_VIDEOS',
    /**
     * @value New
     * @description Single word "New"
     */
    NEW = 'NEW',
    /**
     * @value Newsletter
     */
    NEWSLETTER = 'ACTION_TYPE_NEWSLETTER',
    /**
     * @value Newsletters
     */
    NEWSLETTERS = 'ADMIN.NAV.NEWSLETTER',
    /**
     * @value New category
     */
    NEW_CATEGORY = 'GLOBAL.NEW_CATEGORY',
    /**
     * @value %NB_OF_ITEMS% new items loaded
     * @description This message will be read by screen readers when new items from a list are loaded (after clicking a Load More button, for example). It should indicate how many new items are loaded.
     * This message will not be displayed, it will only be used by screen readers.
     */
    NEW_ITEMS_LOADED_MESSAGE = 'GLOBAL.A11Y_NEW_ITEMS_LOADED_MESSAGE',
    /**
     * @value New language
     */
    NEW_LANGUAGE = 'GLOBAL.NEW_LANGUAGE',
    /**
     * @value New message
     */
    NEW_MESSAGE = 'GLOBAL.NEW_MESSAGE',
    /**
     * @value Next
     * @description useful when allowing user to go to next step.
     */
    NEXT = 'GLOBAL.NEXT',
    /**
     * @value Next month
     * @description Message usually used in a picker to display an action that moves the user to the next month
     */
    NEXT_MONTH = 'GLOBAL.NEXT_MONTH',
    /**
     * @value Next slide
     */
    NEXT_SLIDE = 'LUMX.NEXT_SLIDE',
    /**
     * @value No
     */
    NO = 'GLOBAL.NO',
    /**
     * @value Note
     * @description Is not a verb! This key is used as the label of a field in which users can write a text that will be used as a note, juste like a notepad
     */
    NOTE = 'GLOBAL.NOTE',
    NOTIFICATION = 'NOTIFICATION',
    /**
     * @value Notifications
     * @description Notifications text
     */
    NOTIFICATIONS = 'NOTIFICATIONS',
    /**
     * @value Notify
     */
    NOTIFY = 'GLOBAL.NOTIFY',
    /**
     * @value Maximum number of values reached (%LIMIT%)
     * @description Warning displayed if a certain number of values has been reached
     */
    NOTIF_MAX_VALUES_REACHED = 'GLOBAL.NOTIF_MAX_VALUES_REACHED',
    /**
     * @value How did you get here?
     * @description Error title displayed to the user when he tries to access a page he is not allowed to
     */
    NOT_ALLOWED = 'GLOBAL.NOT_ALLOWED',
    /**
     * @value Only administrators can see this page.
     * @description Text displayed when an unauthorized user access an admin page
     */
    NOT_AUTHORIZED = 'ADMIN.NOT_AUTHORIZED',
    /**
     * @value Not created
     */
    NOT_CREATED = 'GLOBAL.NOT_CREATED',
    /**
     * @value Not delivered
     */
    NOT_DELIVERED = 'GLOBAL.NOT_DELIVERED',
    /**
     * @value Not enough data
     * @description Not anough data information. Used in analytics for example
     */
    NOT_ENOUGH_DATA = 'GLOBAL.NOT_ENOUGH_DATA',
    /**
     * @value Not helpful
     */
    NOT_HELPFUL = 'GLOBAL.NOT_HELPFUL',
    /**
     * @value Not mandatory
     */
    NOT_MANDATORY = 'GLOBAL.NOT_MANDATORY',
    /**
     * @value Not planned
     * @description Used as a label to give the indication that data below have not been planned (yet)
     */
    NOT_PLANNED = 'GLOBAL.NOT_PLANNED',
    /**
     * @value Not ready
     * @description Not ready
     */
    NOT_READY = 'GLOBAL.NOT_READY',
    /**
     * @value Not saved
     */
    NOT_SAVED = 'GLOBAL.NOT_SAVED',
    /**
     * @value Not sent
     */
    NOT_SENT = 'GLOBAL.NOT_SENT',
    /**
     * @value Not started
     */
    NOT_STARTED = 'GLOBAL.NOT_STARTED',
    /**
     * @value Not tested
     * @description Neutral status label shown before a connection or configuration has been tested (e.g. next to a Test button).
     */
    NOT_TESTED = 'GLOBAL.NOT_TESTED',
    /**
     * @value Not used
     * @description Used as a status flag to indicate that the current data is not used
     */
    NOT_USED = 'GLOBAL.NOT_USED',
    /**
     * @value Not visible to reader
     * @description Text to warn editors that their content is not visible to reader or a specific information is not visible to reader
     */
    NOT_VISIBLE_TO_READER = 'GLOBAL.NOT_VISIBLE_TO_READER',
    /**
     * @value No description
     * @description Label to display when an item has no description
     */
    NO_DESCRIPTION = 'GLOBAL.NO_DESCRIPTION',
    /**
     * @value No result found, please try another query or filters.
     * @description The generic message displayed in a filtered widget list when there is no result matching the filters.
     */
    NO_FILTERED_RESULTS = 'GLOBAL.NO_FILTERED_RESULTS',
    /**
     * @value No more than %NB_LINES% lines
     */
    NO_MORE_THAN_X_LINES = 'GLOBAL.NO_MORE_THAN_X_LINES',
    /**
     * @value No results
     * @description message used for displaying that there were no results.
     */
    NO_RESULTS = 'GLOBAL.NO_RESULTS',
    /**
     * @value There are no results for <strong>%TEXT%</strong>. <br>Please try another entry.
     * @description Start of the error message when no user found.
     *
     * Parameters:
     * - TEXT: the search term that was not found
     */
    NO_RESULTS_FOR = 'GLOBAL.NO_RESULTS_FOR',
    /**
     * @value No results found
     */
    NO_RESULTS_FOUND = 'GLOBAL.NO_RESULTS_FOUND',
    /**
     * @value No results for this filter.
     * @description Text used to display that there were no results found for the currently applied filter
     */
    NO_RESULT_FOR_THIS_FILTER = 'GLOBAL.NO_RESULT_FOR_THIS_FILTER',
    /**
     * @value Number
     */
    NUMBER = 'GLOBAL.NUMBER',
    /**
     * @value Add each scope from the third-party that you want to allow for the connector. Hit enter to add a scope.
     */
    OAUTH_SCOPES_HELPER = 'CONNECTORS.SCOPES_HELPER',
    /**
     * @value Add an action
     */
    OAUTH_SCOPES_PLACEHOLDER = 'CONNECTORS.ADD_AN_ACTION',
    /**
     * @value {"one":"%NUMBER% Day","other":"%NUMBER% Days"}
     */
    OCCURRENCES_DAY = 'JOURNEYS_CORE.DAY',
    /**
     * @value Ok
     * @description Message usually used to dismiss another message.
     */
    OK = 'GLOBAL.OK',
    /**
     * @value Okta
     */
    OKTA = 'GLOBAL.OKTA',
    /**
     * @value Oldest
     * @description The text displayed when the oldest items are displayed first
     */
    OLDEST = 'GLOBAL.OLDEST',
    /**
     * @value Oldest to latest
     * @description Text used to sort items from oldest to latest.
     */
    OLDEST_TO_LATEST = 'GLOBAL.OLDEST_TO_LATEST',
    /**
     * @value Sharepoint
     * @description Text to be used when referencing the Sharepoint service
     */
    ONE_DRIVE = 'GLOBAL.ONE_DRIVE',
    /**
     * @value Pick at least one group
     */
    ONE_GROUP_LIMIT = 'GLOBAL.ONE_GROUP_LIMIT',
    /**
     * @value Ongoing
     */
    ONGOING = 'GLOBAL.ONGOING',
    /**
     * @value Add only numerical characters
     * @description Text used as an error when an input allow only number to be given
     */
    ONLY_NUMBERS = 'GLOBAL.ONLY_NUMBERS',
    /**
     * @value On %DATE%
     * @description Used to display the date something has benne sent, like in "this message has been sent on March 30, 2022"
     */
    ON_DATE = 'GLOBAL.ON_DATE',
    /**
     * @value On
     * @description Used to display the date something has been sent, like in "this message has been sent on March 30, 2022" BUT as a title, so "on" is the only word on its line :
     * > On
     * > March 30, 2022
     */
    ON_DATE_TITLE = 'GLOBAL.ON_DATE_TITLE',
    /**
     * @value Open
     * @description action to open a document
     */
    OPEN = 'GLOBAL.OPEN',
    /**
     * @value Opened
     */
    OPENED = 'GLOBAL.OPENED',
    /**
     * @value Open app
     * @description Title of the button which lets the user continue with the mobile app
     */
    OPEN_APP = 'GLOBAL.OPEN_APP',
    /**
     * @value Open image in fullscreen.
     * @description Label for the button wrapping the image and allowing to open the image in fullscreen
     */
    OPEN_IMAGE_IN_FULLSCREEN = 'GLOBAL.OPEN_IMAGE_IN_FULLSCREEN',
    /**
     * @value Open image %NB% in fullscreen.
     * @description Label for the button wrapping an image inside a group of images, allowing to open that image in fullscreen. %NB% is the 1-based position of the image in the group. (Ex: Open image 2 in fullscreen.)
     */
    OPEN_IMAGE_NB_IN_FULLSCREEN = 'GLOBAL.OPEN_IMAGE_NB_IN_FULLSCREEN',
    /**
     * @value Open in a new tab
     */
    OPEN_NEW_TAB = 'GLOBAL.OPEN_NEW_TAB',
    /**
     * @value Open %ENT%
     * @description Text to use to say that we want to open an element
     */
    OPEN_SOMETHING = 'GLOBAL.OPEN_SOMETHING',
    /**
     * @value Operator
     */
    OPERATOR = 'GLOBAL.OPERATOR',
    /**
     * @value Optional
     * @description "optional" usually displayed when something is not mandatory
     */
    OPTIONAL = 'GLOBAL.OPTIONAL',
    /**
     * @value Options
     * @description Generic "Options" key
     */
    OPTIONS = 'GLOBAL.OPTIONS',
    /**
     * @value Or
     */
    OR = 'GLOBAL.OR',
    /**
     * @value Order
     */
    ORDER = 'FRONT.SETTINGS.ORDERING',
    /**
     * @value Order by
     * @description Generic "Order by" message
     */
    ORDER_BY = 'GLOBAL.ORDER_BY',
    /**
     * @value First uploaded
     * @description Sort files by uploaded date in ascending order.
     */
    ORDER_BY_UPLOADED_DATE_ASC = 'GLOBAL.ORDER_BY_UPLOADED_DATE_ASC',
    /**
     * @value Last uploaded
     * @description Sort files by uploaded date in descending order.
     */
    ORDER_BY_UPLOADED_DATE_DESC = 'GLOBAL.ORDER_BY_UPLOADED_DATE_DESC',
    /**
     * @value Organization
     * @description Organisation
     */
    ORGANIZATION = 'GLOBAL.ORGANIZATION',
    /**
     * @value Other
     */
    OTHER = 'GLOBAL.OTHER',
    /**
     * @value Other possible translation languages
     */
    OTHER_POSSIBLE_TRANSLATIONS_LANGS = 'GLOBAL.OTHER_POSSIBLE_TRANSLATIONS_LANGS',
    /**
     * @value Other sites
     * @description Can be used anywhere we want to distinguish from the current site
     */
    OTHER_SITES = 'GLOBAL.OTHER_SITES',
    /**
     * @value Outdated
     */
    OUTDATED = 'REPORTS.POST_REPORT_DIALOG_OUTDATED_REASON',
    /**
     * @value Overdue
     */
    OVERDUE = 'GLOBAL.OVERDUE',
    /**
     * @todo change to GLOBAL.OVERVIEW
     * @value Overview
     */
    OVERVIEW = 'ADMIN.ANALYTICS.DASHBOARD_TAB',
    /**
     * @value Ownership
     * @description Global word to be used across the product to display entities that can have their `ownership` configured
     */
    OWNERSHIP = 'GLOBAL.OWNERSHIP',
    /**
     * @value This page is private and cannot be seen by other people.
     * @description Text explaining that the current page is private and cannot be seen by other people
     */
    PAGE_IS_PRIVATE = 'GLOBAL.PAGE_IS_PRIVATE',
    /**
     * @value %CURRENT_PAGE% on %LAST_PAGE%
     */
    PAGINATION_ON = 'GLOBAL.PAGINATION_ON',
    /**
     * @value Parameters
     */
    PARAMETERS = 'GLOBAL.PARAMETERS',
    /**
     * @value Partial edit
     * @description Partial edit permission for the menu
     */
    PARTIAL_EDIT = 'ROLES.MENU_PARTIAL_EDIT_ACTION',
    /**
     * @value Password
     */
    PASSWORD = 'ADMIN_USER_DIRECTORY_PASSWORD',
    /**
     * @value Paste URL
     */
    PASTE_URL = 'GLOBAL.PASTE_URL',
    /**
     * @value Pause
     * @description The word pause, that can be reused in multiple scenarios.
     */
    PAUSE = 'GLOBAL.PAUSE',
    /**
     * @value Paused
     */
    PAUSED = 'GLOBAL.PAUSED',
    /**
     * @value Pause
     * @description Used as the verb like in "pause this broadcast"
     */
    PAUSE_VERB = 'GLOBAL.PAUSE_VERB',
    /**
     * @value Pending
     */
    PENDING = 'GLOBAL.PENDING',
    /**
     * @value People
     * @description Word to describe people in a generic context
     */
    PEOPLE = 'GLOBAL.PEOPLE',
    /**
     * @value {"one":"person","other":"people"}
     * @description Internal note: we also have GLOBAL.PEOPLE (only plural), GLOBAL.NB_PEOPLE (with singular and plural and a variable)
     */
    PEOPLE_SINGULAR_PLURAL = 'GLOBAL.PEOPLE_SINGULAR_PLURAL',
    /**
     * @value per
     * @description Used to be concatenated in other translations
     */
    PER = 'GLOBAL.PER',
    /**
     * @value Permissions
     * @description Text that can be used as the title of a section where the user can manage the permissions of a given entity (visibility, access restriction, etc...).
     */
    PERMISSIONS = 'GLOBAL.PERMISSIONS',
    /**
     * @value Pick a date
     * @description Label to indicate to pick a date
     */
    PICK_DATE = 'GLOBAL.PICK_DATE',
    /**
     * @value Pick groups
     * @description Text that can be used as a a field label inviting the user to select which groups of users can access a given entity
     */
    PICK_GROUPS = 'GLOBAL.PICK_GROUPS',
    /**
     * @value Pick an icon
     */
    PICK_ICON = 'GLOBAL.PICK_ICON',
    /**
     * @value Place activity
     * @description Place activity
     */
    PLACE_ACTIVITY = 'GLOBAL.PLACE_ACTIVITY',
    /**
     * @value Planned
     */
    PLANNED = 'GLOBAL.PLANNED',
    /**
     * @value Platform
     */
    PLATFORM = 'GLOBAL.PLATFORM',
    /**
     * @value Play
     * @description The action of starting playback on a media or game control.
     */
    PLAY = 'GLOBAL.PLAY',
    /**
     * @value Playlists
     * @description Text used has a title to indicate user can see the playlists
     */
    PLAYLISTS = 'PLAY.PLAYLISTS',
    /**
     * @value Please wait...
     * @description Message to display when loading a service that might take a long time (more than 3s).
     */
    PLEASE_WAIT = 'GLOBAL.PLEASE_WAIT',
    /**
     * @value Post
     * @description A placeholder key that will be reused whenever we reference the word 'Post' on its own.
     */
    POST = 'GLOBAL.POST',
    /**
     * @value Posts
     */
    POSTS = 'FRONT.COMMUNITY.POSTS',
    /**
     * @value Press enter to add.
     * @description instructions saying the user can press enter to add a new group
     */
    PRESS_ENTER_TO_ADD = 'FRONT.SOCIAL_ADVOCACY.PROGRAM_MEMBERSHIPS.PRESS_ENTER_TO_ADD',
    /**
     * @value Preview
     * @description Text to be displayed on an action that will preview an entity
     */
    PREVIEW = 'GLOBAL.PREVIEW',
    /**
     * @value Previous
     * @description Text to display when an action triggers a "Previous" state
     */
    PREVIOUS = 'GLOBAL.PREVIOUS',
    /**
     * @value Previous month
     * @description Message usually used in a picker to display an action that moves the user to the previous month
     */
    PREVIOUS_MONTH = 'GLOBAL.PREVIOUS_MONTH',
    /**
     * @value Previous slide
     */
    PREVIOUS_SLIDE = 'LUMX.PREVIOUS_SLIDE',
    /**
     * @value Primary color
     * @description Label of the section where we choose the background color of the mobile application configuration.
     */
    PRIMARY_COLOR = 'MOBILE.CONFIGURATION_COLOR_THEME_LABEL',
    /**
     * @value Priority
     * @description Label to describe the priority of something
     */
    PRIORITY = 'GLOBAL.PRIORITY',
    /**
     * @value Private
     * @description Text to use when displaying that something is private.
     */
    PRIVATE = 'GLOBAL.PRIVATE',
    /**
     * @value Processing
     */
    PROCESSING = 'GLOBAL.PROCESSING',
    /**
     * @value Profile
     */
    PROFILE = 'GLOBAL.PROFILE',
    /**
     * Reference: LUMAPPS_APPLICATIONS.PROFILE_FIELDS_PLACEHOLDER
     * @value Select profile fields
     */
    PROFILE_FIELDS_PLACEHOLDER = 'LUMAPPS_APPLICATIONS.PROFILE_FIELDS_PLACEHOLDER',
    /**
     * @value Steps with a linear progression
     * @description Label describing the purpose of the set of steps on a progress tracker.
     */
    PROGRESS_TRACKER_LABEL = 'GLOBAL.PROGRESS_TRACKER_LABEL',
    /**
     * @value Promoted search
     * @description Name of the "promote" feature
     */
    PROMOTED_SEARCH = 'GLOBAL.PROMOTED_SEARCH',
    /**
     * @value Properties
     */
    PROPERTIES = 'FRONT.SETTINGS.PROPERTIES',
    /**
     * @value Provider
     * @description Provider
     */
    PROVIDER = 'CONNECTORS.PROVIDER',
    /**
     * @value Provider settings
     */
    PROVIDERS = 'ADMIN.NAV.PROVIDER',
    /**
     * @value Provisioning
     */
    PROVISIONING = 'GLOBAL.PROVISIONING',
    /**
     * @value Public
     * @description Text to use when displaying that something is public.
     *
     */
    PUBLIC = 'GLOBAL.PUBLIC',
    /**
     * @value Publication
     * @description Title of the Scheduled section in the edit dialog
     * Defines a video publication
     */
    PUBLICATION = 'PLAY.PUBLICATION',
    /**
     * @value Publication date
     * @description Content's publication date
     */
    PUBLICATION_DATE = 'GLOBAL.PUBLICATION_DATE',
    /**
     * @value Publication types
     * @description Global string to describe publication types.
     */
    PUBLICATION_TYPES = 'GLOBAL.PUBLICATION_TYPES',
    /**
     * @value Public link
     * @description text to display when showing a public link
     */
    PUBLIC_LINK = 'GLOBAL.PUBLIC_LINK',
    /**
     * @value Publish
     * @description Generic "Publish" key
     */
    PUBLISH = 'GLOBAL.PUBLISH',
    /**
     * @value Publishable/Unpublishable
     */
    PUBLISHABLE = 'CAN_PAGE_PUBLISH',
    /**
     * @value Published
     */
    PUBLISHED = 'CONTENT_STATUS_LIVE',
    /**
     * @value Published in %LOCATION%
     * @description A part of a sentence stating that an user has published a piece of content in %LOCATION%
     *
     * Keep the first word with Capital (see screenshot)
     */
    PUBLISHED_IN_LOCATION = 'GLOBAL.PUBLISHED_IN_LOCATION',
    /**
     * @value Published on
     * @description Text used when displaying when an entity was published. Needs to be used with a date.
     */
    PUBLISHED_ON = 'PUBLISHED_ON',
    /**
     * @value Published on %DATE%
     * @description String to display a publication date.
     */
    PUBLISHED_ON_DATE = 'GLOBAL.PUBLISHED_ON_DATE',
    /**
     * @value Published on: %DATE%
     */
    PUBLISHED_ON_DATE_COLON = 'CONTENT_ADMIN.PUBLISHED_ON_DATE',
    /**
     * @value Published successfully
     * @description Displayed on toaster if element had been published successfully
     */
    PUBLISHED_SUCCESS = 'GLOBAL.PUBLISHED_SUCCESS',
    /**
     * @value Publish now
     * @description The label of the button to publish immediately a scheduled content.
     */
    PUBLISH_NOW = 'DESIGNER.PUBLISH_NOW_LABEL',
    /**
     * @value Quiz
     * @description Simple "quiz" word
     */
    QUIZ = 'GLOBAL.QUIZ',
    /**
     * @value Quiz Game
     * @description Title for learning activity of type quiz game
     */
    QUIZ_GAME = 'GLOBAL.QUIZ_GAME',
    /**
     * @value Ranking
     */
    RANKING = 'GLOBAL.RANKING',
    /**
     * @value Reactions
     * @description Section title that displays reactions, like people reacting with likes and comments to a publication.
     */
    REACTIONS = 'GLOBAL.REACTIONS',
    /**
     * @value Read
     */
    READ = 'ACTION_READ',
    /**
     * @value Received on %DATE%
     * @description Text to be used to show when was an entity received on.
     *
     * Parameters:
     * - DATE: specific reception date
     */
    RECEIVED_ON = 'GLOBAL.RECEIVED_ON',
    /**
     * @value Recent changes have not been saved. Your work will be lost.
     */
    RECENT_CHANGES_NOT_SAVED = 'GLOBAL.RECENT_CHANGES_NOT_SAVED',
    /**
     * @value Recommended
     */
    RECOMMENDED = 'GLOBAL.RECOMMENDED',
    /**
     * @value Redirect URL
     */
    REDIRECT_URL = 'ADMIN.TERMS_AND_CONDITIONS.REDIRECT_URL.LABEL',
    /**
     * @value This language will be used as reference to manage translations.
     */
    REFERENCE_LANGUAGE = 'LANGUAGES.REFERENCE_LANGUAGE',
    /**
     * @value For more information, refer to the <a>documentation</a>
     * @description Text displayed to invite users to check the documentation.
     * The link element will be added around the translation for the word "documentation".
     */
    REFER_TO_DOCUMENTATION_LINK = 'GLOBAL.REFER_TO_DOCUMENTATION_LINK',
    /**
     * @value Refresh
     * @description A placeholder key that will be reused whenever we reference the word 'Refresh' on its own.
     */
    REFRESH = 'GLOBAL.REFRESH',
    /**
     * @value Refuse
     * @description Generic key "Refuse"
     */
    REFUSE = 'GLOBAL.REFUSE',
    /**
     * @value Refused
     */
    REFUSED = 'CONTENT_STATUS_REFUSED',
    /**
     * @value Registration status
     */
    REGISTRATION_STATUS = 'GLOBAL.REGISTRATION_STATUS',
    /**
     * @value Created %RELATIVE_DATE%
     * @description Used for displaying "created at" date relative to today.
     * Ex: Created 1 day ago
     */
    RELATIVE_CREATED_AT = 'GLOBAL.RELATIVE_CREATED_AT',
    /**
     * @value Last modified %RELATIVE_DATE%
     * @description Used for displaying "last modified" date relative to today.
     * Ex: Last modified 1 day ago
     */
    RELATIVE_LAST_MODIFIED_DATE = 'GLOBAL.RELATIVE_LAST_MODIFIED_DATE',
    /**
     * @value Published %RELATIVE_DATE%
     * @description Used for displaying "published" date relative to today.
     * Ex: Published 1 day ago
     */
    RELATIVE_PUBLISHED_DATE = 'GLOBAL.RELATIVE_PUBLISHED_DATE',
    /**
     * @value Received %RELATIVE_DATE%
     */
    RELATIVE_RECEIVED_DATE = 'GLOBAL.RELATIVE_RECEIVED_DATE',
    /**
     * @value Relaunch updates
     */
    RELAUNCH_UPDATES = 'GLOBAL.RELAUNCH_UPDATES',
    /**
     * @value Relevance
     * @description Single word "relevance"
     */
    RELEVANCE = 'GLOBAL.RELEVANCE',
    /**
     * @value Reload
     * @description Generic "Reload" key
     */
    RELOAD = 'GLOBAL.RELOAD',
    /**
     * @value Reload page
     * @description Message to display on an action that will reload the current page
     */
    RELOAD_PAGE = 'GLOBAL.RELOAD_PAGE',
    /**
     * @value Remove
     * @description Useful when allowing the user remove an entity
     */
    REMOVE = 'GLOBAL.REMOVE',
    /**
     * @value Removed
     * @description "Removed" single work
     */
    REMOVED = 'GLOBAL.REMOVED',
    /**
     * @value Remove all
     * @description Remove all
     */
    REMOVE_ALL = 'GLOBAL.REMOVE_ALL',
    /**
     * @value Remove %ENTITY%?
     * @description Generic message displayed in confirm dialogs when removing an item
     */
    REMOVE_ENTITY = 'GLOBAL.REMOVE_ENTITY',
    /**
     * @value Rename
     */
    RENAME = 'GLOBAL.RENAME',
    /**
     * @value Replace
     * @description Generic replace key
     */
    REPLACE = 'GLOBAL.REPLACE',
    /**
     * @value Replace by
     */
    REPLACE_BY = 'GLOBAL.REPLACE_BY',
    /**
     * @value Reply
     * @description Generic "Reply" label
     */
    REPLY = 'GLOBAL.REPLY',
    /**
     * @value Requests
     */
    REQUESTS = 'NOTIFICATION_PRIORITY_NAME_5',
    /**
     * @value {"one":"%COUNT% request","other":"%COUNT% requests"}
     * @description Number of requests, e.g in a community
     *
     * Parameters:
     * - COUNT: number of requests to replace
     */
    REQUESTS_COUNT = 'GLOBAL.REQUESTS_COUNT',
    /**
     * @value Resend
     * @description Used as an action verb to let the user know that she can send something again (when clicking a button, for example)
     */
    RESEND = 'GLOBAL.RESEND',
    /**
     * @value Reset
     * @description Reset generic key
     */
    RESET = 'RESET',
    /**
     * @value Reset filters
     */
    RESET_FILTERS = 'GLOBAL.RESET_FILTERS',
    /**
     * @value Resolve
     */
    RESOLVE = 'GLOBAL.RESOLVE',
    /**
     * @value Resource center
     * @description Label for the resource center icon on the top right side of the top bar
     */
    RESOURCE_CENTER = 'GLOBAL.RESOURCE_CENTER',
    /**
     * @value Restore
     */
    RESTORE = 'GLOBAL.RESTORE',
    /**
     * @value Restored
     */
    RESTORED = 'GLOBAL.RESTORED',
    /**
     * @value Restricted access
     * @description Label to let the user know why she cannot see something. Its access is restricted for some reason.
     */
    RESTRICTED_ACCESS = 'GLOBAL.RESTRICTED_ACCESS',
    /**
     * @value Restricted to
     * @description Text used to indicate that a component has been restricted to some kind of visibility
     */
    RESTRICTED_TO = 'GLOBAL.RESTRICTED_TO',
    /**
     * @value Restrictions
     */
    RESTRICTIONS = 'WIDGET_SETTINGS_RESTRICTIONS',
    /**
     * @value Restrict access
     * @description Text that can be used as a select value to restrict the access of a given entity to a group of users only.
     */
    RESTRICT_ACCESS = 'GLOBAL.RESTRICT_ACCESS',
    /**
     * @value This answer was generated by AI and may be incorrect. Verify important information and report any inaccuracies.
     * @description Disclaimers that a displayed information was generated by AI and should be verified.
     */
    RESULT_GENERATED_BY_AI = 'GLOBAL.RESULT_GENERATED_BY_AI',
    /**
     * @value Recommended
     * @description flag to display a result as recommended
     */
    RESULT_IS_RECOMMENDED = 'FRONT.SEARCH.RESULT_IS_RECOMMENDED',
    /**
     * @value Revert to draft
     * @description Revert a publication, previously published, to a draft state.
     */
    REVERT_TO_DRAFT = 'GLOBAL.REVERT_TO_DRAFT',
    /**
     * @value Right now
     * @description Text used to display that an event occurred in this very exact moment
     */
    RIGHT_NOW = 'RIGHT_NOW',
    /**
     * @value Role
     * @description Roles sorting button placeholder
     */
    ROLE = 'PLAY.ROLE',
    /**
     * @value Roles
     * @description Title of the Roles dialog
     */
    ROLES = 'PLAY.ROLES',
    /**
     * @value Roles settings
     */
    ROLES_SETTINGS = 'GLOBAL.ROLES_SETTINGS',
    /**
     * @value Administrator
     * @description LumApps Play Administrator role
     */
    ROLE_ADMINISTRATOR = 'PLAY.ROLE_ADMINISTRATOR',
    /**
     * @value Rule
     */
    RULE = 'GLOBAL.RULE',
    /**
     * @value Save
     * @description Useful when allowing saving an entity.
     */
    SAVE = 'GLOBAL.SAVE',
    /**
     * @value Saved
     * @description used when displaying an success message upon saving an entity, normally displayed using a notification on the bottom right corner of the screen.
     */
    SAVED = 'GLOBAL.SAVED',
    /**
     * @value Saved as draft on %DATE%
     */
    SAVED_AS_DRAFT_ON = 'GLOBAL.SAVED_AS_DRAFT_ON',
    /**
     * @value Saved on %DATE%
     */
    SAVED_ON = 'GLOBAL.SAVED_ON',
    /**
     * @value Save and insert
     * @description Label used on a button indicating to the user that it will save his changes and directly insert it
     */
    SAVE_AND_INSERT = 'GLOBAL.SAVE_AND_INSERT',
    /**
     * @value Save as draft
     */
    SAVE_AS_DRAFT = 'SAVE_AS_DRAFT',
    /**
     * @value Save changes
     * @description Text used in an action to save the current changes
     */
    SAVE_CHANGES = 'GLOBAL.SAVE_CHANGES',
    /**
     * @value Saving...
     * @description Text to be displayed in a button while the entity is saving
     */
    SAVING = 'GLOBAL.SAVING',
    /**
     * @value Schedule
     * @description Global schedule text
     *
     * "Schedule" is a verb here, for example "I want to schedule this"
     */
    SCHEDULE = 'GLOBAL.SCHEDULE',
    /**
     * @value Scheduled
     * @description Global scheduled text
     */
    SCHEDULED = 'GLOBAL.SCHEDULED',
    /**
     * @value {"one":"%COUNT% scheduled post","other":"%COUNT% scheduled posts"}
     */
    SCHEDULED_COUNT_PLURALIZED = 'GLOBAL.SCHEDULED_COUNT_PLURALIZED',
    /**
     * @value {"one":"%COUNT% scheduling error","other":"%COUNT% scheduling errors"}
     * @description Example:
     *
     * - 1 scheduling error
     * - 4 scheduling errors
     */
    SCHEDULED_ERROR_COUNT_PLURALIZED = 'GLOBAL.SCHEDULED_ERROR_COUNT_PLURALIZED',
    /**
     * @value Scheduled on
     * @description Text to display for showing the date of scheduling for the broadcast
     */
    SCHEDULED_ON = 'BROADCASTS.SCHEDULED_ON',
    /**
     * @value Scheduled on: %DATE%
     */
    SCHEDULED_ON_DATE = 'CONTENT_ADMIN.SCHEDULED_ON_DATE',
    /**
     * @value Scopes
     */
    SCOPES = 'CONNECTORS.SCOPES',
    /**
     * @value Score
     * @description Message used to display either a relevance score or points for a specific entity
     */
    SCORE = 'GLOBAL.SCORE',
    /**
     * @value Search
     */
    SEARCH = 'FRONT.SEARCH',
    /**
     * @value Search by name
     * @description Used for example for text fields placeholders
     */
    SEARCH_BY_NAME = 'GLOBAL.SEARCH_BY_NAME',
    /**
     * @value Search by title
     * @description Global text to be added as a placeholder for a text field that allows to search entities by their title
     */
    SEARCH_BY_TITLE = 'GLOBAL.SEARCH_BY_TITLE',
    /**
     * @value Search by title or author
     * @description Placeholder text used on a search field to search items in a list by title or author
     */
    SEARCH_BY_TITLE_OR_AUTHOR = 'GLOBAL.SEARCH_BY_TITLE_OR_AUTHOR',
    /**
     * @value Search field
     */
    SEARCH_FIELD = 'GLOBAL.SEARCH_FIELD',
    /**
     * @value Search for someone
     * @description Label or placeholder used in user search text fields
     */
    SEARCH_FOR_SOMEONE = 'GLOBAL.SEARCH_FOR_SOMEONE',
    /**
     * @value Search results
     */
    SEARCH_RESULTS = 'GLOBAL.SEARCH_RESULTS',
    /**
     * @value Secondary color
     * @description Text used on color picker tooltip, which indicate a secondary color
     */
    SECONDARY_COLOR = 'GLOBAL.SECONDARY_COLOR',
    /**
     * @value + %COUNT% more
     * @description label of action to display more items
     */
    SEE_MORE_NB_ITEMS = 'FRONT.SEARCH.SEE_MORE_NB_ITEMS',
    /**
     * @value See translation
     * @description See translation generic key
     */
    SEE_TRANSLATION = 'TRANSLATE_CONTENT',
    /**
     * @value Segment
     */
    SEGMENT = 'LOOKER_GLOBAL_SEGMENT',
    /**
     * @value Select
     * @description Global key select
     */
    SELECT = 'GLOBAL.SELECT',
    /**
     * @value {"one":"%COUNT% item selected","other":"%COUNT% items selected"}
     */
    SELECTED_ITEMS_COUNT = 'GLOBAL.SELECTED_ITEMS_COUNT',
    /**
     * @value Selection
     */
    SELECTION = 'GLOBAL.SELECTION',
    /**
     * @value Select All
     */
    SELECT_ALL = 'GLOBAL.SELECT_ALL',
    /**
     * @value Select / Deselect all
     * @description Label of a switch used to activate all notifications for a given device (in-app, email).
     */
    SELECT_ALL_DESELECT_ALL = 'NOTIFICATION.PREFERENCES.TABLE.CHECK_ALL.ROW.LABEL',
    /**
     * @value Select an icon to make this option available.
     * @description Helper text explaining that this option is enabled only if an icon is selected
     */
    SELECT_AN_ICON_TO_MAKE_THIS_OPTION_AVAILABLE = 'GLOBAL.SELECT_AN_ICON_TO_MAKE_THIS_OPTION_AVAILABLE',
    /**
     * @value Select an option
     */
    SELECT_AN_OPTION = 'FRONT.EVENT.DIALOG.LINK_LABEL_PLACEHOLDER',
    /**
     * @value Select author
     * @description Text inviting the user to select an author from a list of users
     */
    SELECT_AUTHOR = 'GLOBAL.SELECT_AUTHOR',
    /**
     * @value Select / Deselect
     * @description Global key in order to display the fact that an element can be selected or deselected
     */
    SELECT_DESELECT = 'GLOBAL.SELECT_DESELECT',
    /**
     * @value Select fields
     * @description Label for field selector (multiple)
     */
    SELECT_FIELDS = 'GLOBAL.SELECT_FIELDS',
    /**
     * @value Select folder
     */
    SELECT_FOLDER = 'GLOBAL.SELECT_FOLDER',
    /**
     * @value Select groups
     * @description Placeholder of a field where you can select groups
     */
    SELECT_GROUPS = 'GLOBAL.SELECT_GROUPS',
    /**
     * @value Select image
     */
    SELECT_IMAGE = 'SELECT_IMAGE',
    /**
     * @value Select languages
     */
    SELECT_LANGUAGES = 'GLOBAL.SELECT_LANGUAGES',
    /**
     * @value Select Provider
     */
    SELECT_PROVIDER = 'GLOBAL.SELECT_PROVIDER',
    /**
     * @value Select a provider type
     */
    SELECT_PROVIDER_TYPE = 'CONNECTORS.SELECT_PROVIDER_TYPE',
    /**
     * @value Select one of the reasons listed.
     * @description Message to inform the user they must select a feedback/reason from a given list. Useful for error messages.
     */
    SELECT_REASON_LISTED = 'GLOBAL.SELECT_REASON_LISTED',
    /**
     * @value Select sites
     */
    SELECT_SITES = 'INSTANCE_PICKER_SUBHEADER_LIBRARY',
    /**
     * @value Select spaces
     * @description "spaces" is a feature name, and should not be translated.
     */
    SELECT_SPACES = 'GLOBAL.SELECT_SPACES',
    /**
     * @value Select a user
     */
    SELECT_USER = 'GLOBAL.SELECT_USER',
    /**
     * @value Select user profile field
     * @description Label of a select field, letting the user know what she's supposed to do with this field
     */
    SELECT_USERPROFILE_FIELD = 'JOURNEY_ADMIN.STAKEHOLDER_USERPROFILE_FIELD_LABEL',
    /**
     * @value Select users
     */
    SELECT_USERS = 'GLOBAL.SELECT_USERS',
    /**
     * @value Self-registration
     */
    SELF_REGISTRATION_TITLE = 'MOBILE_LOGIN.SELF_REGISTRATION_TITLE',
    /**
     * @value Send
     */
    SEND = 'GLOBAL.SEND',
    /**
     * @value Send test
     * @description Label of a button that will allow the user to send a test (for example an email) to someone (depending on context, she will be able to choose or not)
     */
    SEND_TEST = 'GLOBAL.SEND_TEST',
    /**
     * @value Send to
     * @description Text to be displayed when something was "Send to"
     */
    SEND_TO = 'GLOBAL.SEND_TO',
    /**
     * @value Sent
     * @description Global sent translation key
     */
    SENT = 'GLOBAL.SENT',
    /**
     * @value Sent date
     */
    SENT_DATE = 'ADMIN.NEWSLETTER.SENT_DATE',
    /**
     * @value Sent on
     * @description Text to be displayed when something was "Sent on"
     */
    SENT_ON = 'GLOBAL.SENT_ON',
    /**
     * @value Sent to
     * @description Text to be displayed when a broadcast was "Sent to". This will be displayed as a title of a section that will read, Sent to: X people
     */
    SENT_TO = 'GLOBAL.SENT_TO',
    /**
     * @value Not authorized
     * @description Not authorized generic error message
     */
    SERVER_ERROR_NOT_AUTHORIZED = 'SERVER_ERROR_NOT_AUTHORIZED',
    /**
     * @value This service is temporarily unavailable
     * @description used as a title when an error occured during a page loading
     */
    SERVICE_UNAVAILABLE = 'GLOBAL.SERVICE_UNAVAILABLE',
    /**
     * @value Settings
     * @description Settings generic key
     */
    SETTINGS = 'GLOBAL.SETTINGS',
    /**
     * @value Retrieve credentials from the provider application.
     */
    SETTINGS_DESCRIPTION = 'CONNECTORS.SETTINGS_DESCRIPTION',
    /**
     * @value Setup
     * @description Setup (configuration) of the provider form
     */
    SETUP = 'CONNECTORS.SETUP',
    /**
     * @value Set as source
     */
    SET_AS_SOURCE = 'LANGUAGES.SET_AS_SOURCE',
    /**
     * @value Set Up
     * @description Use as a verb to describe the process of preparing hardware and installed apps for initial use. Two words as a verb, one word as an adjective and a noun. Don't hyphenate.
     */
    SET_UP = 'GLOBAL.SET_UP',
    /**
     * @value Several mandatory fields are missing
     */
    SEVERAL_MANDATORY_FIELDS_MISSING = 'GLOBAL.SEVERAL_MANDATORY_FIELDS_MISSING',
    /**
     * @value Share
     * @description Generic Share key
     */
    SHARE = 'GLOBAL.SHARE',
    /**
     * @value Shared
     * @description Text to use when displaying that something is shared.
     */
    SHARED = 'GLOBAL.SHARED',
    /**
     * @value Share via %APP%
     * @description "Share via" action that can be used with any app.
     * ("Share via Teams", "Share via LinkedIn", "Share via Slack", etc.
     */
    SHARE_VIA_APP = 'GLOBAL.SHARE_VIA_APP',
    /**
     * @value Show
     */
    SHOW = 'SHOW',
    /**
     * @value Show advanced settings
     */
    SHOW_ADVANCED_SETTINGS = 'GLOBAL.SHOW_ADVANCED_SETTINGS',
    /**
     * @value Show all
     * @description Show all generic key
     */
    SHOW_ALL = 'SHOW_All',
    /**
     * @value Show archived
     * @description Text to be displayed when showing archived
     */
    SHOW_ARCHIVED = 'GLOBAL.SHOW_ARCHIVED',
    /**
     * @value Show as:
     * @description Prefix to select a group / user to display information as.
     */
    SHOW_AS = 'GLOBAL.SHOW_AS',
    /**
     * @value Show details
     */
    SHOW_DETAILS = 'GLOBAL.SHOW_DETAILS',
    /**
     * @value Show filters
     * @description action di show filters on the search page
     */
    SHOW_FILTERS = 'FRONT.SEARCH.SHOW_FILTERS',
    /**
     * @value {"one":"Show issue","other":"Show issues"}
     * @description Display a tooltip by hovering a warning when we missing stakeholders
     *
     * A stakeholder is someone who is “linked” to an employee of the company, for example their Manager, or their HR Manager, or their teammate.
     *
     *
     */
    SHOW_ISSUE = 'GLOBAL.SHOW_ISSUE',
    /**
     * @value Show less
     * @description Text of a button that hides some items (= it shows less items). "Show" is a verb here
     */
    SHOW_LESS = 'GLOBAL.SHOW_LESS',
    /**
     * @value Show Message
     * @description Label to put in context where you need to show a message.
     */
    SHOW_MESSAGE = 'GLOBAL.SHOW_MESSAGE',
    /**
     * @value Show more
     * @description Text of a button that show more items of any kind. "Show" is a verb here
     */
    SHOW_MORE = 'GLOBAL.SHOW_MORE',
    /**
     * @value Show only visible items
     */
    SHOW_ONLY_VISIBLE_ITEMS = 'GLOBAL.SHOW_ONLY_VISIBLE_ITEMS',
    /**
     * @value Show suggestions
     * @description Button label for combobox type components to explain that clicking it will display suggestions.
     */
    SHOW_SUGGESTIONS = 'GLOBAL.SHOW_SUGGESTIONS',
    /**
     * @value Sign in
     */
    SIGN_IN = 'LOGIN_CLASSIC_SIGN_IN',
    /**
     * @value MMM DD YYYY hh:mm a
     * @description A moment JS date format to apply to Zendesk search results.
     */
    SIMPLE_DATE_FORMAT_COMPLETE = 'SIMPLE_DATE_FORMAT_COMPLETE',
    /**
     * @value Site
     */
    SITE = 'ADMIN_GAMIFICATION_LEADERBOARD_SCOPE_INSTANCE',
    /**
     * @value Sites
     * @description Refer to several instances
     */
    SITES = 'GLOBAL.SITES',
    /**
     * @value Site administrators
     */
    SITE_ADMINS = 'GLOBAL.SITE_ADMINS',
    /**
     * @value Site groups
     */
    SITE_GROUPS = 'FEED_GROUP_OTHERS',
    /**
     * @value Site languages
     */
    SITE_LANGUAGES = 'GLOBAL.SITE_LANGUAGES',
    /**
     * @value Size
     */
    SIZE = 'GLOBAL.SIZE',
    /**
     * @value Skip
     */
    SKIP = 'GLOBAL.SKIP',
    /**
     * @value Skip links
     * @description Name of the hidden navigation containing the "skip" links that allows to skip the start of the site (top bar / navigation  )
     */
    SKIP_LINKS = 'GLOBAL.SKIP_LINKS',
    /**
     * @deprecated use GLOBAL.SKIP_TO_CONTENT instead
     * @value Skip navigation
     * @description Skip navigation hidden link. Used for accessibility purpose.
     */
    SKIP_NAVIGATION = 'FRONT.HEADER.SKIP_NAVIGATION',
    /**
     * @value Skip to Ask AI
     * @description Skip to Ask AI hidden link. Used for accessibility purpose.
     */
    SKIP_TO_ASK_AI = 'GLOBAL.SKIP_TO_ASK_AI',
    /**
     * @value Skip to content
     * @description Skip to content hidden link. Used for accessibility purpose.
     */
    SKIP_TO_CONTENT = 'GLOBAL.SKIP_TO_CONTENT',
    /**
     * @value Skip to navigation
     * @description Skip to navigation hidden link. Used for accessibility purpose.
     */
    SKIP_TO_NAVIGATION = 'GLOBAL.SKIP_TO_NAVIGATION',
    /**
     * @value Slide
     * @description A word to name one slide of a slideshow or a carousel.
     */
    SLIDE = 'GLOBAL.SLIDE',
    /**
     * @value Slideshow
     */
    SLIDESHOW = 'FRONT.SETTINGS.VIEW_MODE.SLIDESHOW',
    /**
     * @value Slide %NB%
     * @description Text to define what index a slide of a slideshow is at.
     * Can be used as label of slide controls.
     * (Ex: Slide 5)
     */
    SLIDE_NB = 'GLOBAL.SLIDE_NB',
    /**
     * @value Slide %NB_SLIDE% of %NB_TOTAL%
     * @description Text to provide the current position of a slide in a slideshow from the total.
     * Ex: Slide 5 of 6.
     */
    SLIDE_NB_OF_NB_TOTAL = 'GLOBAL.SLIDE_NB_OF_NB_TOTAL',
    /**
     * @value Slug
     * @description Here the "Slug" is a unique identifier of the site. This identifier is human readable.
     */
    SLUG = 'LOOKER_GLOBAL_SLUG',
    /**
     * @value Small
     * @description A word to describe tiny things
     */
    SMALL = 'GLOBAL.SMALL',
    /**
     * @value Social
     * @description now also the title of the 'Social' section of the space navigation explore menu
     */
    SOCIAL = 'GLOBAL.SOCIAL',
    /**
     * @value Social Advocacy
     */
    SOCIAL_ADVOCACY = 'ADMIN.NAV.SOCIAL_ADVOCACY',
    /**
     * @value Some files have failed to upload. Remove them and try again.
     * @description Message to display when some files have failed to upload but others didn't.
     */
    SOME_FILES_FAILED_TO_UPLOAD = 'GLOBAL.SOME_FILES_FAILED_TO_UPLOAD',
    /**
     * @value Sorted by: %SORT%
     * @description Text that allows to display to the user that the set of results was sorted by some attribute.
     *
     * Parameters:
     * - SORT: sorted by attribute
     */
    SORTED_BY = 'GLOBAL.SORTED_BY',
    /**
     * @value Sorting
     * @description Text used as a title to sort items
     */
    SORTING = 'GLOBAL.SORTING',
    /**
     * @value A to Z
     * @description Sort alphabetically
     */
    SORT_ALPHABETICALLY_ASC = 'GLOBAL.SORT_ALPHABETICALLY_ASC',
    /**
     * @value Z to A
     * @description Sort in reverse alphabetical order
     */
    SORT_ALPHABETICALLY_DESC = 'GLOBAL.SORT_ALPHABETICALLY_DESC',
    /**
     * @value Sort by
     * @description Generic Sort by
     */
    SORT_BY = 'GLOBAL.SORT_BY',
    /**
     * @value Sorted by alphabetical order
     */
    SORT_BY_ALPHABETIC_ORDER = 'GLOBAL.SORT_RULE',
    /**
     * @value Least comments first
     * @description Sort order label showing items with the least comments first (ascending by comments count)
     */
    SORT_COMMENTS_ASC = 'GLOBAL.SORT_COMMENTS_ASC',
    /**
     * @value Most comments first
     * @description Sort order label showing items with the most comments first (descending by comments count)
     */
    SORT_COMMENTS_DESC = 'GLOBAL.SORT_COMMENTS_DESC',
    /**
     * @value %SORTING_CRITERIA% (A to Z)
     * @description Create a label for sorting options, which is used for alphabetical order based on dynamic criteria.
     *
     * Example: "Title (A to Z)" where Title is the SORTING_CRITERIA. This will be the label for an alphabetical sorting based on the title.
     */
    SORT_CRITERIA_ALPHABETICALLY_ASC = 'GLOBAL.SORT_CRITERIA_ALPHABETICALLY_ASC',
    /**
     * @value %SORTING_CRITERIA% (Z to A)
     * @description Create a label for sorting options, which is used for reversed alphabetical order based on dynamic criteria.
     *
     * Example: "Title (Z to A)" where Title is the SORTING_CRITERIA. This will be the label for an alphabetical sorting based on the title.
     */
    SORT_CRITERIA_ALPHABETICALLY_DESC = 'GLOBAL.SORT_CRITERIA_ALPHABETICALLY_DESC',
    /**
     * @value Latest update
     * @description The label for the sorting option that displays the latest updated entities first
     */
    SORT_LATEST_UDPATE = 'GLOBAL.SORT_LATEST_UDPATE',
    /**
     * @value Least likes first
     * @description Sort order label showing items with the least likes first (ascending by likes count)
     */
    SORT_LIKES_ASC = 'GLOBAL.SORT_LIKES_ASC',
    /**
     * @value Most likes first
     * @description Sort order label showing items with the most likes first (descending by likes count)
     */
    SORT_LIKES_DESC = 'GLOBAL.SORT_LIKES_DESC',
    /**
     * @value Manual order
     * @description Type of list sorting: manual order
     */
    SORT_MANUAL_ORDER = 'GLOBAL.SORT_MANUAL_ORDER',
    /**
     * @value Most Recent
     * @description Sort newest on top
     */
    SORT_NEWEST = 'GLOBAL.SORT_NEWEST',
    /**
     * @value Least Recent
     * @description Sort oldest on top
     */
    SORT_OLDEST = 'GLOBAL.SORT_OLDEST',
    /**
     * @value Oldest update
     * @description The label for the sorting option that displays the oldest updated entities first
     */
    SORT_OLDEST_UPDATE = 'GLOBAL.SORT_OLDEST_UPDATE',
    /**
     * @value Source
     * @description Single word "source"
     */
    SOURCE = 'GLOBAL.SOURCE',
    /**
     * @value Sources
     * @description Single word "sources"
     */
    SOURCES = 'GLOBAL.SOURCES',
    /**
     * @value Source language
     */
    SOURCE_LANGUAGE = 'LANGUAGES.SOURCE_LANGUAGE',
    /**
     * @value Source language is the original language of your text.
     */
    SOURCE_LANGUAGE_DESCRIPTION = 'LANGUAGES.SOURCE_LANGUAGE_DESCRIPTION',
    /**
     * @value Space
     * @description Default singular name for the feature known as "Spaces" (a new version of the communities)
     * The term "Space" must not be translated, it is a male name.
     */
    SPACE = 'GLOBAL.SPACE',
    /**
     * @value Spaces
     * @description Default name for the feature known as "Spaces" (a new version of the communities)
     * The term "Space" must not be translated, it is a male name.
     *
     */
    SPACES = 'GLOBAL.FEATURE_SPACES',
    /**
     * @value Speakers
     */
    SPEAKERS = 'GLOBAL.SPEAKERS',
    /**
     * @value %FORMAT% encoding
     */
    SPECIFIC_FILE_ENCODING = 'GLOBAL.SPECIFIC_FILE_ENCODING',
    /**
     * @value Start
     */
    START = 'GLOBAL.START',
    /**
     * @value Starting...
     */
    STARTING = 'GLOBAL.STARTING',
    /**
     * @value Start date
     * @description Display the text Start date
     */
    START_DATE = 'START_DATE',
    /**
     * @value Start time
     */
    START_TIME = 'START_TIME',
    /**
     * @value Start writing...
     * @description Placeholder displayed in a field where the user is supposed to write a message
     */
    START_WRITING = 'GLOBAL.START_WRITING',
    /**
     * @value Statistics
     */
    STATISTICS = 'GLOBAL.STATISTICS',
    /**
     * @value Status
     * @description Single word "status"
     */
    STATUS = 'GLOBAL.STATUS',
    /**
     * @value Status changed for %STATUS%
     * @description Displayed in a toaster/alert to let the user know that the status of something has been changed. %STATUS% is the new value such as live, paused, archived etc.
     */
    STATUS_CHANGED_FOR = 'GLOBAL.STATUS_CHANGED_FOR',
    /**
     * @value Step %STEP_INDEX% of %STEPS_NUMBER%
     * @description Displayed in the header of each step when running the learning agent's wizard-like flow
     */
    STEP_OF_WIZARD = 'GLOBAL.STEP_OF_WIZARD',
    /**
     * @value Streams
     * @description Name of the Beekeeper streams feature: the feed of posts shared with a group of people. Used as the title of the page embedding it.
     */
    STREAMS = 'GLOBAL.STREAMS',
    /**
     * @value {"one":"Style","other":"Styles"}
     */
    STYLES = 'GLOBAL.STYLES',
    /**
     * @value Subject
     * @description This will serve as the label of the subject field of the contact form widget.
     */
    SUBJECT = 'GLOBAL.SUBJECT',
    /**
     * @value Submit
     */
    SUBMIT = 'GLOBAL.SUBMIT',
    /**
     * @value Subscriptions
     */
    SUBSCRIPTIONS = 'SOCIAL_PROFILE_SUBSCRIPTIONS',
    /**
     * @value Subtitle
     */
    SUBTITLE = 'FRONT.SETTINGS.SUBTITLE',
    /**
     * @value {"one":"%COUNT%  SUB-CATEGORY","other":"%COUNT% SUB-CATEGORIES"}
     * @description to  display SUB_CATEGORY or SUB_CATEGORIES on the counter of sub categories on the learning widget
     */
    SUB_CATEGORY = 'GLOBAL.SUB_CATEGORY',
    /**
     * @value Success
     */
    SUCCESS = 'MICRO_APPS_RUNS.SUCCESS',
    /**
     * @value {"one":"Suggestion","other":"Suggestions"}
     * @description Suggestion section for other items
     */
    SUGGESTION = 'GLOBAL.SUGGESTION',
    /**
     * @value Summary
     */
    SUMMARY = 'COMMUNITY_DETAILS',
    /**
     * @value Surveys
     * @description Label or title used for the Surveys section/page
     */
    SURVEYS = 'GLOBAL.SURVEYS',
    /**
     * @value Switch back to the current view
     */
    SWITCH_BACK_CURRENT_VIEW = 'GLOBAL.SWITCH_BACK_CURRENT_VIEW',
    /**
     * @value Switch to the new view
     */
    SWITCH_TO_NEW_VIEW = 'GLOBAL.SWITCH_TO_NEW_VIEW',
    /**
     * @value Tags
     */
    TAGS = 'GLOBAL.TAGS',
    /**
     * @value Tasks
     * @description Currently used as a label in a filter, describing the type of those filters
     */
    TASKS = 'GLOBAL.TASKS',
    /**
     * @value Template
     * @description Word used to mention a community template for instance.
     */
    TEMPLATE = 'GLOBAL.TEMPLATE',
    /**
     * @value Templates
     * @description A placeholder key that will be reused whenever we reference the word 'Templates' on its own.
     */
    TEMPLATES = 'GLOBAL.TEMPLATES',
    /**
     * @value {"one":"Deleting the template is irreversible. You will delete the entire configuration.","other":"Deleting %NB% templates is irreversible. You will delete their entire configuration."}
     * @description Confirm message displayed in a dialog when deleting templates
     */
    TEMPLATE_DELETE_CONFIRM_MESSAGE = 'GLOBAL.TEMPLATE_DELETE_CONFIRM_MESSAGE',
    /**
     * @value Deleting %TITLE% template is irreversible. You will delete the entire configuration.
     * @description Confirm message to display in a delete dialog when deleting a specific template
     */
    TEMPLATE_DELETE_CONFIRM_MESSAGE_WITH_TITLE = 'GLOBAL.TEMPLATE_DELETE_CONFIRM_MESSAGE_WITH_TITLE',
    /**
     * @value Temporality
     * @description Label of the Temporality filter on the Event Picker
     */
    TEMPORALITY = 'EVENTS.PICKER_TEMPORALITY_LABEL',
    /**
     * @value Future events
     */
    TEMPORALITY_FUTURE = 'FRONT.WIDGET_POST_LIST.SETTINGS.FUTURE_EVENTS',
    /**
     * @value Ongoing events
     */
    TEMPORALITY_ONGOING = 'FRONT.WIDGET_POST_LIST.SETTINGS.ONGOING_EVENTS',
    /**
     * @value Past events
     */
    TEMPORALITY_PAST = 'FRONT.WIDGET_POST_LIST.SETTINGS.PAST_EVENTS',
    /**
     * @value Terms and conditions
     * @description Title of the dialog used to display the choice to accept or refuse the terms and conditons of a site and title of the admin section
     */
    TERMS_AND_CONDITIONS = 'GLOBAL.TERMS_AND_CONDITIONS',
    /**
     * @value Test
     * @description Test section label on micro app api action
     */
    TEST = 'PAGE.MICROAPP_ACTION_DIALOG.TEST_LABEL',
    /**
     * @value Test KO
     */
    TEST_KO = 'GLOBAL.TEST_KO',
    /**
     * @value Test OK
     */
    TEST_OK = 'GLOBAL.TEST_OK',
    /**
     * @value Text
     * @description Single word "Text"
     */
    TEXT = 'GLOBAL.TEXT',
    /**
     * @value Text color
     */
    TEXT_COLOR = 'FRONT.TEXT_EDITOR.HEADINGS.COLOR_SELECTION',
    /**
     * @value Then
     */
    THEN = 'GLOBAL.THEN',
    /**
     * @value There are no insights
     */
    THERE_ARE_NO_INSIGHTS = 'GLOBAL.THERE_ARE_NO_INSIGHTS',
    /**
     * @value This link
     */
    THIS_LINK = 'GLOBAL.THIS_LINK',
    /**
     * @value Thumbnail
     */
    THUMBNAIL = 'GLOBAL.THUMBNAIL',
    /**
     * @value Tiles
     * @description "Tiles" is a UI/design definition and should not be translated.
     */
    TILES = 'GLOBAL.TILES',
    /**
     * @value Time
     */
    TIME = 'TIME',
    /**
     * @value Timezone
     */
    TIMEZONE = 'GLOBAL.TIMEZONE',
    /**
     * @value Time (approximately)
     */
    TIME_APPROXIMATELY = 'GLOBAL.TIME_APPROXIMATELY',
    /**
     * @value m[m] s[s]
     * @description It's a time conversion format, only translate what is between "[ ]"
     */
    TIME_FORMAT_SHORT = 'GLOBAL.TIME_FORMAT_SHORT',
    /**
     * @value Title
     * @description Generic Title key
     */
    TITLE = 'GLOBAL.TITLE',
    /**
     * @value Title contains only spaces
     * @description Error message explaining that the filled in title only contains spaces
     */
    TITLE_CONTAINS_ONLY_SPACES = 'GLOBAL.TITLE_CONTAINS_ONLY_SPACES',
    /**
     * @value Title is mandatory
     * @description Error text used to indicate to our users that the title of an entity is mandatory.
     */
    TITLE_MANDATORY = 'GLOBAL.TITLE_MANDATORY',
    /**
     * @value To
     * @description Use to display 'To' label as in "To the manager team", "To the billing service"
     */
    TO = 'GLOBAL.TO',
    /**
     * @value Today
     * @description Single word "Today"
     */
    TODAY = 'GLOBAL.TODAY',
    /**
     * @value Toggle
     * @description Generic Toggle key
     */
    TOGGLE = 'GLOBAL.TOGGLE',
    /**
     * @value Select/unselect all
     */
    TOGGLE_ALL = 'TOGGLE_ALL',
    /**
     * @value Toggle "%FILTER_LABEL%" filter options
     * @description Text set as label of buttons that toggles options of a given filter
     */
    TOGGLE_FILTER_OPTIONS = 'GLOBAL.TOGGLE_FILTER_OPTIONS',
    /**
     * @value Token URL
     */
    TOKEN_URL = 'CONNECTORS.TOKEN_URI',
    /**
     * @value URL to retrieve the token in the third-party service.
     */
    TOKEN_URL_HELPER = 'CONNECTORS.TOKEN_URI_HELPER',
    /**
     * @value Tool
     */
    TOOL = 'LOOKER_AGENT_TOOL_FILTER',
    /**
     * @value Toolbox
     */
    TOOLBOX = 'GLOBAL.TOOLBOX',
    /**
     * @value Toolboxes
     */
    TOOLBOXES = 'GLOBAL.TOOLBOXES',
    /**
     * @value Topics
     * @description Displays topics' label
     */
    TOPICS = 'GLOBAL.TOPICS',
    /**
     * @value Total views
     * @description Text used to label a card displaying the total views count of an entity
     */
    TOTAL_VIEWS = 'GLOBAL.TOTAL_VIEWS',
    /**
     * @value To acknowledge
     * @description Usually displayed in a color chip/flag to show that a user should still confirme that she has read/taken into consideration the related resource or notification (not done yet)
     */
    TO_ACKNOWLEDGE = 'GLOBAL.TO_ACKNOWLEDGE',
    /**
     * @value Comment
     * @description Action of writing a comment
     */
    TO_COMMENT = 'GLOBAL.TO_COMMENT',
    /**
     * @value To complete
     */
    TO_COMPLETE = 'GLOBAL.TO_COMPLETE',
    /**
     * @value To do
     * @description Simple label to mention that a task should be done
     */
    TO_DO = 'GLOBAL.TO_DO',
    /**
     * @value To %NB% %SUBJECT%
     * @description Text used to display things like "To 10 people", "To 3 services", "To 1 team"
     */
    TO_NB_SUBJECT = 'GLOBAL.TO_NB_SUBJECT',
    /**
     * @value To open
     * @description Short label to be displayed in a flag that tells the user something needs to be opened (a link/file etc.)
     */
    TO_OPEN = 'GLOBAL.TO_OPEN',
    /**
     * @value To %PERSON%
     * @description This key aims to display the recipient of something.
     * For example, it can be used to indicate that a notification will be shown "To Ms. Johns" or "To your manager".
     */
    TO_PERSON = 'GLOBAL.TO_PERSON',
    /**
     * @value To view
     */
    TO_VIEW = 'GLOBAL.TO_VIEW',
    /**
     * @value Training
     */
    TRAINING = 'GLOBAL.TRAINING',
    /**
     * @value Training courses
     */
    TRAINING_COURSES = 'LEARNING.TRAINING_COURSES',
    /**
     * @value Translate
     * @description translate button action
     */
    TRANSLATE = 'GLOBAL.TRANSLATE',
    /**
     * @value Translate with AI
     */
    TRANSLATE_WITH_AI = 'GLOBAL.TRANSLATE_WITH_AI',
    /**
     * @value Translation manager
     */
    TRANSLATION_MANAGER = 'LANGUAGES.TRANSLATION_MANAGER',
    /**
     * @value Try again
     * @description Used as a button label, proposing to the user to try again if they click on it
     */
    TRY_AGAIN = 'GLOBAL.TRY_AGAIN',
    /**
     * @value Try another filter
     * @description Message displayed to the user to advise him to choose another filter.
     * This message is typically used in a filtered list where no results were found.
     */
    TRY_ANOTHER_FILTER = 'GLOBAL.TRY_ANOTHER_FILTER',
    /**
     * @value Try another query.
     */
    TRY_ANOTHER_QUERY = 'GLOBAL.TRY_ANOTHER_QUERY',
    /**
     * @value Try another query or filter.
     */
    TRY_ANOTHER_QUERY_OR_FILTER = 'GLOBAL.TRY_ANOTHER_QUERY_OR_FILTER',
    /**
     * @value Try the beta
     */
    TRY_BETA = 'GLOBAL.TRY_BETA',
    /**
     * @value Try the new page
     * @description Label of a link toward the new versionb of the current page, used for migration purpose
     */
    TRY_NEW_PAGE = 'GLOBAL.TRY_NEW_PAGE',
    /**
     * @value Try to reload or come back later.
     * @description Used when an error occurs and we want to let the user know that they need to retry
     */
    TRY_RELOAD = 'GLOBAL.TRY_RELOAD',
    /**
     * @value Tutorial
     */
    TUTORIAL = 'GLOBAL.TUTORIAL',
    /**
     * @value Tutorials
     */
    TUTORIALS = 'TUTORIAL_PLURAL',
    /**
     * @value Type
     * @description Generic "type" key
     */
    TYPE = 'GLOBAL.TYPE',
    /**
     * @value Types
     * @description types facet name
     */
    TYPES = 'MS_TYPES',
    /**
     * @value Unable to save. Try again.
     */
    UNABLE_TO_SAVE = 'GLOBAL.UNABLE_TO_SAVE',
    /**
     * @value Unarchive
     */
    UNARCHIVE = 'CONTENT_SET_TO_UNARCHIVE',
    /**
     * @value Unarchived
     */
    UNARCHIVED = 'GLOBAL.UNARCHIVED',
    /**
     * @value Unavailable
     */
    UNAVAILABLE = 'MARKETPLACE.UNAVAILABLE',
    /**
     * @value Unavailable community
     * @description Text indicating that the community is currently unavailable
     */
    UNAVAILABLE_COMMUNITY = 'GLOBAL.UNAVAILABLE_COMMUNITY',
    /**
     * @value Unavailable content
     * @description Text indicating that the piece of content is currently unavailable
     */
    UNAVAILABLE_CONTENT = 'GLOBAL.UNAVAILABLE_CONTENT',
    /**
     * @value This feature is not available on Internet Explorer
     */
    UNAVAILABLE_FEATURE_IE = 'FRONT.WARNING.UNAVAILABLE_FEATURE_IE',
    /**
     * @value Unavailable Group
     * @description Indicator when a group is unavailable (because it has been deleted for instance). Reuse the same translation as in the key "GLOBAL.GROUP"
     */
    UNAVAILABLE_GROUP = 'GLOBAL.UNAVAILABLE_GROUP',
    /**
     * @value Undated
     * @description Used as a timeline label for elements that does not have a date.
     */
    UNDATED = 'GLOBAL.UNDATED',
    /**
     * @value Undefined
     */
    UNDEFINED = 'GLOBAL.UNDEFINED',
    /**
     * @value Unfollow
     * @description Unfollow generic key
     */
    UNFOLLOW = 'GLOBAL.UNFOLLOW',
    /**
     * @value Unit
     */
    UNIT = 'GLOBAL.UNIT',
    /**
     * @value Unknown
     */
    UNKNOWN = 'FRONT.COMMUNITY.POST_EVENT.ATTENDEES_UNKNOWN',
    /**
     * @value Unknown user
     * @description Generic Unknown user key
     */
    UNKNOWN_USER = 'UNKNOWN_USER',
    /**
     * @value Unlock
     * @description Label for the icon button that unlocks a group of linked inputs
     */
    UNLOCK = 'GLOBAL.UNLOCK',
    /**
     * @value Unnamed
     * @description Global key to be used when an entity does not have a name and we need to display a text instead of nothing
     */
    UNNAMED = 'GLOBAL.UNNAMED',
    /**
     * @value Unpublish
     */
    UNPUBLISH = 'CONTENT_SET_TO_DRAFT',
    /**
     * @value Unpublished
     */
    UNPUBLISHED = 'CONTENT.STATUS_DRAFT',
    /**
     * @value Unsaved modifications
     * @description Text displayed when you leave an edition of an entity without saving your changes.
     */
    UNSAVED_MODIFICATIONS = 'GLOBAL.DISCARD_UNSAVED_CHANGES_DIALOG.TITLE',
    /**
     * @value All modifications will be deleted. Do you want to continue?
     * @description The description displayed when you leave an edition of an entity without saving your changes.
     */
    UNSAVED_MODIFICATIONS_DESCRIPTION = 'GLOBAL.DISCARD_UNSAVED_CHANGES_DIALOG.DESCRIPTION',
    /**
     * @value Untitled
     * @description Text to display when an entity has no title
     */
    UNTITLED = 'GLOBAL.UNTITLED',
    /**
     * @value Unverified
     * @description Used as a status flag for any data that can be either verified or unverified
     */
    UNVERIFIED = 'GLOBAL.UNVERIFIED',
    /**
     * @value Update
     * @description Generic Update key
     */
    UPDATE = 'GLOBAL.UPDATE',
    /**
     * @value Updated
     */
    UPDATED = 'GLOBAL.UPDATED',
    /**
     * @value Updated at
     */
    UPDATED_AT = 'UPDATED_AT',
    /**
     * @value Updated by
     * @description user entity that have updated a content / community / post / or anything else.
     * Updated by *username*.
     * for instance:    Updated by John Doe
     */
    UPDATED_BY = 'GLOBAL.UPDATED_BY',
    /**
     * @value Updated date
     * @description Updated date generic key
     */
    UPDATED_DATE = 'UPDATED_DATE',
    /**
     * @value Updated on
     */
    UPDATED_ON = 'GLOBAL.UPDATED_ON',
    /**
     * @value Updated on: %DATE%
     */
    UPDATED_ON_DATE = 'CONTENT_ADMIN.UPDATE_ON_DATE',
    /**
     * @value Updates
     * @description Generic Updates key
     */
    UPDATES = 'GLOBAL.UPDATES',
    /**
     * @value Updates status
     */
    UPDATES_STATUS = 'GLOBAL.UPDATES_STATUS',
    /**
     * @value Upgrade
     * @description Action to upgrade something to make it better.
     */
    UPGRADE = 'GLOBAL.UPGRADE',
    /**
     * @value Uploading the file
     */
    UPLOADING_FILE = 'GLOBAL.UPLOADING_FILE',
    /**
     * @value Upload an image
     * @description Generic text to be displayed in order to show an action that uploads a single image
     */
    UPLOAD_AN_IMAGE = 'GLOBAL.UPLOAD_AN_IMAGE',
    /**
     * @value Upload has failed
     * @description Error message displayed when the upload has failed
     */
    UPLOAD_FAILED = 'GLOBAL.ERROR.UPLOAD_FAILED',
    /**
     * @value Upload file
     * @description Usage: text to be display on a button that will trigger a file upload.
     *
     * @TODO: refactor this key in order to remove NANNY.
     */
    UPLOAD_FILE = 'ADMIN.NANNY.UPLOAD_FILE',
    /**
     * @value Upload a square image, less than 300 KB.
     */
    UPLOAD_FILE_RESTRICTION = 'GLOBAL.UPLOAD_FILE_RESTRICTION',
    /**
     * @value Upload logo
     */
    UPLOAD_LOGO = 'ADMIN_INSTANCE_SETTINGS_LOGO_UPLOAD',
    /**
     * @value URL
     * @description Text used to label an URL input
     */
    URL = 'GLOBAL.URL',
    /**
     * @value The URL is incorrect. Verify the URL format and try again.
     * @description Error message to indicate to an user that his url is in the worng format (like text instead of url).
     */
    URL_ERROR = 'GLOBAL.URL_ERROR',
    /**
     * @value This URL is invalid.
     * @description In mobile navigation admin page, the error message displayed when the user type an invalid url in the URL input
     */
    URL_FIELD_ERROR_MESSAGE = 'ADMIN.MOBILE.NAVIGATION.EXTERNAL_LINK.URL_FIELD.ERROR_MESSAGE',
    /**
     * @value URL
     * @description In Mobile navigation admin page, the label of the URL input.
     */
    URL_FIELD_LABEL = 'ADMIN.MOBILE.NAVIGATION.EXTERNAL_LINK.URL_FIELD.LABEL',
    /**
     * @value Add a URL link such as https://www.example.com.
     * @description Helper to indicate to an user what url format is expected to the input.
     */
    URL_HELPER = 'GLOBAL.URL_HELPER',
    /**
     * @value Used
     * @description Used as a status flag to indicate that the current data is used
     */
    USED = 'GLOBAL.USED',
    /**
     * @value Used by
     */
    USED_BY = 'GLOBAL.USED_BY',
    /**
     * @value User
     * @description a user of the application
     */
    USER = 'GLOBAL.USER',
    /**
     * @value Username
     */
    USERNAME = 'GLOBAL.USERNAME',
    /**
     * @value Users
     * @description Generic Users key
     */
    USERS = 'GLOBAL.USERS',
    /**
     * @value {"one":"%COUNT% user","other":"%COUNT% users"}
     * @description Number of users, e.g in a community
     *
     * Parameters:
     * - COUNT: total amount of users
     */
    USERS_COUNT = 'GLOBAL.USERS_COUNT',
    /**
     * @value User added successfully
     */
    USER_ADDED_SUCCESS_MESSAGE = 'USER_DIRECTORY_ADD_SUCCESS',
    /**
     * @value Users access the piece of content in their preferred language only if a version is available in that language. If no other language version is available, users access the source language version.
     */
    USER_CONTENT_ACCESS = 'LANGUAGES.USER_CONTENT_ACCESS',
    /**
     * @value User directories
     */
    USER_DIRECTORIES = 'USER_DIRECTORY_PLURAL',
    /**
     * @value User directory
     */
    USER_DIRECTORY = 'GLOBAL.USER_DIRECTORY',
    /**
     * @value All time user engagement
     * @description user engagement generic key
     */
    USER_ENGAGEMENT = 'GLOBAL.USER_ENGAGEMENT',
    /**
     * @value User profile
     * @description Tooltip of the "my profile" button
     */
    USER_PROFILE = 'GLOBAL.USER_PROFIL',
    /**
     * @value User profile fields
     * @description Label of the "User profile fields" form field of the search settings admin page.
     */
    USER_PROFILE_FIELDS_LABEL = 'ADMIN.SEARCH_SETTINGS.USER_PROFILE_FIELDS_LABEL',
    /**
     * @value Use default values
     */
    USE_DEFAULT_VALUES = 'USE_DEFAULT_VALUES',
    /**
     * @value Use "%VALUE%"
     * @description If the value searched by the user is not found in the suggested values, we allow the user to click on "Use Value" to add this value to the list of elements selected.
     */
    USE_VALUE = 'GLOBAL.USE_VALUE',
    /**
     * @value Validate
     */
    VALIDATE = 'PORTAL.REVIEW.SUBMIT.VALIDATE',
    /**
     * @value Value
     */
    VALUE = 'GLOBAL.VALUE',
    /**
     * @value Values
     * @description Must be plural, used to describe more that one value
     */
    VALUES = 'GLOBAL.VALUES',
    /**
     * @value Verified
     * @description Used as a status flag for any data that can be either verified or unverified
     */
    VERIFIED = 'GLOBAL.VERIFIED',
    /**
     * @value Versions
     */
    VERSIONS = 'LANGUAGES.VERSIONS',
    /**
     * @value Video
     * @description this is a basic entry for a video
     */
    VIDEO = 'GLOBAL.VIDEO',
    /**
     * @value Videos
     * @description Videos
     */
    VIDEOS = 'GLOBAL.VIDEOS',
    /**
     * @value Videos / Playlists
     * @description A short label to list both videos and playlists
     */
    VIDEOS_PLAYLISTS = 'GLOBAL.VIDEOS_PLAYLISTS',
    /**
     * @value Video / Playlist
     */
    VIDEO_PLAYLIST = 'SEARCH_PLUS_VIDEO-PLAYLIST/VIDEO_TAB',
    /**
     * @value View
     */
    VIEW = 'VIEW',
    /**
     * @value Viewed
     */
    VIEWED = 'GLOBAL.VIEWED',
    /**
     * @value Views
     */
    VIEWS = 'GLOBAL.VIEWS',
    /**
     * @value View all
     * @description Label for a button to view the full list content
     */
    VIEW_ALL = 'VIEW_ALL',
    /**
     * @value Display site
     * @description Action when the user hover the logo in the back-office
     */
    VIEW_HOMEPAGE = 'ADMIN.VIEW_HOMEPAGE',
    /**
     * @value Display profile
     * @description The description of the action when you click on the profile button
     */
    VIEW_USER_PROFILE = 'GLOBAL.VIEW_USER_PROFILE',
    /**
     * @value Visibility
     * @description Visibility generic key
     */
    VISIBILITY = 'GLOBAL.VISIBILITY',
    /**
     * @value Visible by
     */
    VISIBLE_BY = 'VISIBLE_BY',
    /**
     * @value Warning
     * @description Label used in a warning status of an element (info panel...)
     */
    WARNING = 'GLOBAL.WARNING',
    /**
     * @value You will delete the entire configuration.
     * @description Warning message when the user is about to remove a complex element from the rich text editor
     */
    WARNING_DELETE = 'WREX_CORE.WARNING_DELETE',
    /**
     * @value If you leave now, you will lose your unsaved changes.
     */
    WARNING_UNSAVED_CHANGES = 'GLOBAL.WARNING_UNSAVED_CHANGES',
    /**
     * @value Website
     * @description Display label website
     */
    WEBSITE = 'GLOBAL.WEBSITE',
    /**
     * @value Web & Mobile applications
     */
    WEB_AND_MOBILE_APP = 'GLOBAL.WEB_AND_MOBILE_APP',
    /**
     * @value Weeks
     */
    WEEKS = 'GLOBAL.WEEKS',
    /**
     * @value Widget
     */
    WIDGET = 'GLOBAL.WIDGET',
    /**
     * @value Work in progress
     */
    WIP = 'GLOBAL.WORK_IN_PROGRESS',
    /**
     * @value Withdraw
     * @description Used as a verb on a call to action to let the user know clicking it will take something away from a list.
     */
    WITHDRAW = 'GLOBAL.WITHDRAW',
    /**
     * @value Workflow
     * @description Workflow
     */
    WORKFLOW = 'GLOBAL.WORKFLOW',
    /**
     * @value Workflows
     */
    WORKFLOWS = 'GLOBAL.WORKFLOWS',
    /**
     * @value Write your text here.
     * @description Placeholder for text article text content
     */
    WRITE_YOUR_TEXT_HERE = 'FRONT.ARTICLES.DIALOG.CONTENT_PLACEHOLDER',
    /**
     * @value Wrong format file
     * @description Error message when upload wrong format file
     */
    WRONG_FORMAT_FILE = 'GLOBAL.WRONG_FORMAT_FILE',
    /**
     * @value %FILE_FORMAT% files only
     */
    X_FILES_ONLY = 'GLOBAL.X_FILES_ONLY',
    /**
     * @value year
     * @description Used to be concatenated in other translations
     */
    YEAR = 'GLOBAL.YEAR',
    /**
     * @value years
     */
    YEARS = 'GLOBAL.YEARS',
    /**
     * @value Yes
     */
    YES = 'GLOBAL.YES',
    /**
     * @value Yesterday
     * @description Single word "Yesterday"
     */
    YESTERDAY = 'GLOBAL.YESTERDAY',
    /**
     * @value Zendesk
     * @description Text to be used when referencing the Zendesk service
     */
    ZENDESK = 'SEARCH_PLUS_ZENDESK_TAB',
    /**
     * @value Zoom in
     * @description Key used to describe what the + button does in a zooming context, on a pdf embed for example
     */
    ZOOM_IN = 'GLOBAL.ZOOM_IN',
    /**
     * @value Zoom out
     * @description Key used to describe what the - button does in a zooming context, on a pdf embed for example
     */
    ZOOM_OUT = 'GLOBAL.ZOOM_OUT',
}
export const getServerError = (serverError: string) => `SERVER_ERROR_${serverError}`;
